(function() {
    var s = this
      , v = s._
      , g = {}
      , a = Array.prototype
      , p = Object.prototype
      , u = Function.prototype
      , t = a.push
      , e = a.slice
      , r = a.concat
      , o = p.toString
      , h = p.hasOwnProperty
      , k = a.forEach
      , C = a.map
      , w = a.reduce
      , b = a.reduceRight
      , A = a.filter
      , _ = a.every
      , x = a.some
      , T = a.indexOf
      , I = a.lastIndexOf
      , q = Array.isArray
      , $ = Object.keys
      , Y = u.bind
      , l = function(n) {
        return n instanceof l ? n : this instanceof l ? (this._wrapped = n,
        void 0) : new l(n)
    };
    typeof exports == "undefined" ? s._ = l : (typeof module != "undefined" && module.exports && (exports = module.exports = l),
    exports._ = l),
    l.VERSION = "1.4.3";
    var F = l.each = l.forEach = function(n, d, y) {
        if (n != null) {
            if (k && n.forEach === k)
                n.forEach(d, y);
            else if (n.length === +n.length) {
                for (var P = 0, D = n.length; D > P; P++)
                    if (d.call(y, n[P], P, n) === g)
                        return
            } else
                for (var O in n)
                    if (l.has(n, O) && d.call(y, n[O], O, n) === g)
                        return
        }
    }
    ;
    l.map = l.collect = function(n, d, y) {
        var P = [];
        return n == null ? P : C && n.map === C ? n.map(d, y) : (F(n, function(D, O, M) {
            P[P.length] = d.call(y, D, O, M)
        }),
        P)
    }
    ;
    var J = "Reduce of empty array with no initial value";
    l.reduce = l.foldl = l.inject = function(n, d, y, P) {
        var D = 2 < arguments.length;
        if (n == null && (n = []),
        w && n.reduce === w)
            return P && (d = l.bind(d, P)),
            D ? n.reduce(d, y) : n.reduce(d);
        if (F(n, function(O, M, R) {
            D ? y = d.call(P, y, O, M, R) : (y = O,
            D = !0)
        }),
        !D)
            throw new TypeError(J);
        return y
    }
    ,
    l.reduceRight = l.foldr = function(n, d, y, P) {
        var D = 2 < arguments.length;
        if (n == null && (n = []),
        b && n.reduceRight === b)
            return P && (d = l.bind(d, P)),
            D ? n.reduceRight(d, y) : n.reduceRight(d);
        var O = n.length;
        if (O !== +O) {
            var M = l.keys(n);
            O = M.length
        }
        if (F(n, function(R, K, V) {
            K = M ? M[--O] : --O,
            D ? y = d.call(P, y, n[K], K, V) : (y = n[K],
            D = !0)
        }),
        !D)
            throw new TypeError(J);
        return y
    }
    ,
    l.find = l.detect = function(n, d, y) {
        var P;
        return G(n, function(D, O, M) {
            return d.call(y, D, O, M) ? (P = D,
            !0) : void 0
        }),
        P
    }
    ,
    l.filter = l.select = function(n, d, y) {
        var P = [];
        return n == null ? P : A && n.filter === A ? n.filter(d, y) : (F(n, function(D, O, M) {
            d.call(y, D, O, M) && (P[P.length] = D)
        }),
        P)
    }
    ,
    l.reject = function(n, d, y) {
        return l.filter(n, function(P, D, O) {
            return !d.call(y, P, D, O)
        }, y)
    }
    ,
    l.every = l.all = function(n, d, y) {
        d || (d = l.identity);
        var P = !0;
        return n == null ? P : _ && n.every === _ ? n.every(d, y) : (F(n, function(D, O, M) {
            return (P = P && d.call(y, D, O, M)) ? void 0 : g
        }),
        !!P)
    }
    ;
    var G = l.some = l.any = function(n, d, y) {
        d || (d = l.identity);
        var P = !1;
        return n == null ? P : x && n.some === x ? n.some(d, y) : (F(n, function(D, O, M) {
            return P || (P = d.call(y, D, O, M)) ? g : void 0
        }),
        !!P)
    }
    ;
    l.contains = l.include = function(n, d) {
        return n != null && (T && n.indexOf === T ? n.indexOf(d) != -1 : G(n, function(y) {
            return y === d
        }))
    }
    ,
    l.invoke = function(n, d) {
        var y = e.call(arguments, 2);
        return l.map(n, function(P) {
            return (l.isFunction(d) ? d : P[d]).apply(P, y)
        })
    }
    ,
    l.pluck = function(n, d) {
        return l.map(n, function(y) {
            return y[d]
        })
    }
    ,
    l.where = function(n, d) {
        return l.isEmpty(d) ? [] : l.filter(n, function(y) {
            for (var P in d)
                if (d[P] !== y[P])
                    return !1;
            return !0
        })
    }
    ,
    l.max = function(n, d, y) {
        if (!d && l.isArray(n) && n[0] === +n[0] && 65535 > n.length)
            return Math.max.apply(Math, n);
        if (!d && l.isEmpty(n))
            return -1 / 0;
        var P = {
            computed: -1 / 0,
            value: -1 / 0
        };
        return F(n, function(D, O, M) {
            var R = d ? d.call(y, D, O, M) : D;
            R >= P.computed && (P = {
                value: D,
                computed: R
            })
        }),
        P.value
    }
    ,
    l.min = function(n, d, y) {
        if (!d && l.isArray(n) && n[0] === +n[0] && 65535 > n.length)
            return Math.min.apply(Math, n);
        if (!d && l.isEmpty(n))
            return 1 / 0;
        var P = {
            computed: 1 / 0,
            value: 1 / 0
        };
        return F(n, function(D, O, M) {
            var R = d ? d.call(y, D, O, M) : D;
            P.computed > R && (P = {
                value: D,
                computed: R
            })
        }),
        P.value
    }
    ,
    l.shuffle = function(n) {
        var d, y = 0, P = [];
        return F(n, function(D) {
            d = l.random(y++),
            P[y - 1] = P[d],
            P[d] = D
        }),
        P
    }
    ;
    var Q = function(n) {
        return l.isFunction(n) ? n : function(d) {
            return d[n]
        }
    };
    l.sortBy = function(n, d, y) {
        var P = Q(d);
        return l.pluck(l.map(n, function(D, O, M) {
            return {
                value: D,
                index: O,
                criteria: P.call(y, D, O, M)
            }
        }).sort(function(D, O) {
            var M = D.criteria
              , R = O.criteria;
            if (M !== R) {
                if (M > R || M === void 0)
                    return 1;
                if (R > M || R === void 0)
                    return -1
            }
            return D.index < O.index ? -1 : 1
        }), "value")
    }
    ;
    var i = function(n, d, y, P) {
        var D = {}
          , O = Q(d || l.identity);
        return F(n, function(M, R) {
            var K = O.call(y, M, R, n);
            P(D, K, M)
        }),
        D
    };
    l.groupBy = function(n, d, y) {
        return i(n, d, y, function(P, D, O) {
            (l.has(P, D) ? P[D] : P[D] = []).push(O)
        })
    }
    ,
    l.countBy = function(n, d, y) {
        return i(n, d, y, function(P, D) {
            l.has(P, D) || (P[D] = 0),
            P[D]++
        })
    }
    ,
    l.sortedIndex = function(n, d, y, P) {
        y = y == null ? l.identity : Q(y);
        for (var D, O = y.call(P, d), M = 0, R = n.length; R > M; )
            D = M + R >>> 1,
            O > y.call(P, n[D]) ? M = D + 1 : R = D;
        return M
    }
    ,
    l.toArray = function(n) {
        return n ? l.isArray(n) ? e.call(n) : n.length === +n.length ? l.map(n, l.identity) : l.values(n) : []
    }
    ,
    l.size = function(n) {
        return n == null ? 0 : n.length === +n.length ? n.length : l.keys(n).length
    }
    ,
    l.first = l.head = l.take = function(n, d, y) {
        return n == null ? void 0 : d == null || y ? n[0] : e.call(n, 0, d)
    }
    ,
    l.initial = function(n, d, y) {
        return e.call(n, 0, n.length - (d == null || y ? 1 : d))
    }
    ,
    l.last = function(n, d, y) {
        return n == null ? void 0 : d == null || y ? n[n.length - 1] : e.call(n, Math.max(n.length - d, 0))
    }
    ,
    l.rest = l.tail = l.drop = function(n, d, y) {
        return e.call(n, d == null || y ? 1 : d)
    }
    ,
    l.compact = function(n) {
        return l.filter(n, l.identity)
    }
    ;
    var c = function(n, d, y) {
        return F(n, function(P) {
            l.isArray(P) ? d ? t.apply(y, P) : c(P, d, y) : y.push(P)
        }),
        y
    };
    l.flatten = function(n, d) {
        return c(n, d, [])
    }
    ,
    l.without = function(n) {
        return l.difference(n, e.call(arguments, 1))
    }
    ,
    l.uniq = l.unique = function(n, d, y, P) {
        l.isFunction(d) && (P = y,
        y = d,
        d = !1);
        var D = y ? l.map(n, y, P) : n
          , O = []
          , M = [];
        return F(D, function(R, K) {
            (d ? K && M[M.length - 1] === R : l.contains(M, R)) || (M.push(R),
            O.push(n[K]))
        }),
        O
    }
    ,
    l.union = function() {
        return l.uniq(r.apply(a, arguments))
    }
    ,
    l.intersection = function(n) {
        var d = e.call(arguments, 1);
        return l.filter(l.uniq(n), function(y) {
            return l.every(d, function(P) {
                return 0 <= l.indexOf(P, y)
            })
        })
    }
    ,
    l.difference = function(n) {
        var d = r.apply(a, e.call(arguments, 1));
        return l.filter(n, function(y) {
            return !l.contains(d, y)
        })
    }
    ,
    l.zip = function() {
        for (var n = e.call(arguments), d = l.max(l.pluck(n, "length")), y = Array(d), P = 0; d > P; P++)
            y[P] = l.pluck(n, "" + P);
        return y
    }
    ,
    l.object = function(n, d) {
        if (n == null)
            return {};
        for (var y = {}, P = 0, D = n.length; D > P; P++)
            d ? y[n[P]] = d[P] : y[n[P][0]] = n[P][1];
        return y
    }
    ,
    l.indexOf = function(n, d, y) {
        if (n == null)
            return -1;
        var P = 0
          , D = n.length;
        if (y) {
            if (typeof y != "number")
                return P = l.sortedIndex(n, d),
                n[P] === d ? P : -1;
            P = 0 > y ? Math.max(0, D + y) : y
        }
        if (T && n.indexOf === T)
            return n.indexOf(d, y);
        for (; D > P; P++)
            if (n[P] === d)
                return P;
        return -1
    }
    ,
    l.lastIndexOf = function(n, d, y) {
        if (n == null)
            return -1;
        var P = y != null;
        if (I && n.lastIndexOf === I)
            return P ? n.lastIndexOf(d, y) : n.lastIndexOf(d);
        for (var D = P ? y : n.length; D--; )
            if (n[D] === d)
                return D;
        return -1
    }
    ,
    l.range = function(n, d, y) {
        1 >= arguments.length && (d = n || 0,
        n = 0),
        y = arguments[2] || 1;
        for (var P = Math.max(Math.ceil((d - n) / y), 0), D = 0, O = Array(P); P > D; )
            O[D++] = n,
            n += y;
        return O
    }
    ;
    var m = function() {};
    l.bind = function(n, d) {
        var y, P;
        if (n.bind === Y && Y)
            return Y.apply(n, e.call(arguments, 1));
        if (!l.isFunction(n))
            throw new TypeError;
        return y = e.call(arguments, 2),
        P = function() {
            if (!(this instanceof P))
                return n.apply(d, y.concat(e.call(arguments)));
            m.prototype = n.prototype;
            var D = new m;
            m.prototype = null;
            var O = n.apply(D, y.concat(e.call(arguments)));
            return Object(O) === O ? O : D
        }
    }
    ,
    l.bindAll = function(n) {
        var d = e.call(arguments, 1);
        return d.length == 0 && (d = l.functions(n)),
        F(d, function(y) {
            n[y] = l.bind(n[y], n)
        }),
        n
    }
    ,
    l.memoize = function(n, d) {
        var y = {};
        return d || (d = l.identity),
        function() {
            var P = d.apply(this, arguments);
            return l.has(y, P) ? y[P] : y[P] = n.apply(this, arguments)
        }
    }
    ,
    l.delay = function(n, d) {
        var y = e.call(arguments, 2);
        return setTimeout(function() {
            return n.apply(null, y)
        }, d)
    }
    ,
    l.defer = function(n) {
        return l.delay.apply(l, [n, 1].concat(e.call(arguments, 1)))
    }
    ,
    l.throttle = function(n, d) {
        var y, P, D, O, M = 0, R = function() {
            M = new Date,
            D = null,
            O = n.apply(y, P)
        };
        return function() {
            var K = new Date
              , V = d - (K - M);
            return y = this,
            P = arguments,
            0 >= V ? (clearTimeout(D),
            D = null,
            M = K,
            O = n.apply(y, P)) : D || (D = setTimeout(R, V)),
            O
        }
    }
    ,
    l.debounce = function(n, d, y) {
        var P, D;
        return function() {
            var O = this
              , M = arguments
              , R = y && !P;
            return clearTimeout(P),
            P = setTimeout(function() {
                P = null,
                y || (D = n.apply(O, M))
            }, d),
            R && (D = n.apply(O, M)),
            D
        }
    }
    ,
    l.once = function(n) {
        var d, y = !1;
        return function() {
            return y || (y = !0,
            d = n.apply(this, arguments),
            n = null),
            d
        }
    }
    ,
    l.wrap = function(n, d) {
        return function() {
            var y = [n];
            return t.apply(y, arguments),
            d.apply(this, y)
        }
    }
    ,
    l.compose = function() {
        var n = arguments;
        return function() {
            for (var d = arguments, y = n.length - 1; 0 <= y; y--)
                d = [n[y].apply(this, d)];
            return d[0]
        }
    }
    ,
    l.after = function(n, d) {
        return 0 >= n ? d() : function() {
            return 1 > --n ? d.apply(this, arguments) : void 0
        }
    }
    ,
    l.keys = $ || function(n) {
        if (n !== Object(n))
            throw new TypeError("Invalid object");
        var d = [];
        for (var y in n)
            l.has(n, y) && (d[d.length] = y);
        return d
    }
    ,
    l.values = function(n) {
        var d = [];
        for (var y in n)
            l.has(n, y) && d.push(n[y]);
        return d
    }
    ,
    l.pairs = function(n) {
        var d = [];
        for (var y in n)
            l.has(n, y) && d.push([y, n[y]]);
        return d
    }
    ,
    l.invert = function(n) {
        var d = {};
        for (var y in n)
            l.has(n, y) && (d[n[y]] = y);
        return d
    }
    ,
    l.functions = l.methods = function(n) {
        var d = [];
        for (var y in n)
            l.isFunction(n[y]) && d.push(y);
        return d.sort()
    }
    ,
    l.extend = function(n) {
        return F(e.call(arguments, 1), function(d) {
            if (d)
                for (var y in d)
                    n[y] = d[y]
        }),
        n
    }
    ,
    l.pick = function(n) {
        var d = {}
          , y = r.apply(a, e.call(arguments, 1));
        return F(y, function(P) {
            P in n && (d[P] = n[P])
        }),
        d
    }
    ,
    l.omit = function(n) {
        var d = {}
          , y = r.apply(a, e.call(arguments, 1));
        for (var P in n)
            l.contains(y, P) || (d[P] = n[P]);
        return d
    }
    ,
    l.defaults = function(n) {
        return F(e.call(arguments, 1), function(d) {
            if (d)
                for (var y in d)
                    n[y] == null && (n[y] = d[y])
        }),
        n
    }
    ,
    l.clone = function(n) {
        return l.isObject(n) ? l.isArray(n) ? n.slice() : l.extend({}, n) : n
    }
    ,
    l.tap = function(n, d) {
        return d(n),
        n
    }
    ;
    var S = function(n, d, y, P) {
        if (n === d)
            return n !== 0 || 1 / n == 1 / d;
        if (n == null || d == null)
            return n === d;
        n instanceof l && (n = n._wrapped),
        d instanceof l && (d = d._wrapped);
        var D = o.call(n);
        if (D != o.call(d))
            return !1;
        switch (D) {
        case "[object String]":
            return n == d + "";
        case "[object Number]":
            return n == +n ? n == 0 ? 1 / n == 1 / d : n == +d : d != +d;
        case "[object Date]":
        case "[object Boolean]":
            return +n == +d;
        case "[object RegExp]":
            return n.source == d.source && n.global == d.global && n.multiline == d.multiline && n.ignoreCase == d.ignoreCase
        }
        if (typeof n != "object" || typeof d != "object")
            return !1;
        for (var O = y.length; O--; )
            if (y[O] == n)
                return P[O] == d;
        y.push(n),
        P.push(d);
        var M = 0
          , R = !0;
        if (D != "[object Array]") {
            var K = n.constructor
              , V = d.constructor;
            if (K !== V && !(l.isFunction(K) && K instanceof K && l.isFunction(V) && V instanceof V))
                return !1;
            for (var L in n)
                if (l.has(n, L) && (M++,
                !(R = l.has(d, L) && S(n[L], d[L], y, P))))
                    break;
            if (R) {
                for (L in d)
                    if (l.has(d, L) && !M--)
                        break;
                R = !M
            }
        } else if (M = n.length,
        R = M == d.length)
            for (; M-- && (R = S(n[M], d[M], y, P)); )
                ;
        return y.pop(),
        P.pop(),
        R
    };
    l.isEqual = function(n, d) {
        return S(n, d, [], [])
    }
    ,
    l.isEmpty = function(n) {
        if (n == null)
            return !0;
        if (l.isArray(n) || l.isString(n))
            return n.length === 0;
        for (var d in n)
            if (l.has(n, d))
                return !1;
        return !0
    }
    ,
    l.isElement = function(n) {
        return n && n.nodeType === 1
    }
    ,
    l.isArray = q || function(n) {
        return o.call(n) == "[object Array]"
    }
    ,
    l.isObject = function(n) {
        return n === Object(n)
    }
    ,
    F(["Arguments", "Function", "String", "Number", "Date", "RegExp"], function(n) {
        l["is" + n] = function(d) {
            return o.call(d) == "[object " + n + "]"
        }
    }),
    l.isArguments(arguments) || (l.isArguments = function(n) {
        return n && l.has(n, "callee")
    }
    ),
    l.isFunction = function(n) {
        return typeof n == "function"
    }
    ,
    l.isFinite = function(n) {
        return isFinite(n) && !isNaN(parseFloat(n))
    }
    ,
    l.isNaN = function(n) {
        return l.isNumber(n) && n != +n
    }
    ,
    l.isBoolean = function(n) {
        return n === !0 || n === !1 || o.call(n) == "[object Boolean]"
    }
    ,
    l.isNull = function(n) {
        return n === null
    }
    ,
    l.isUndefined = function(n) {
        return n === void 0
    }
    ,
    l.has = function(n, d) {
        return h.call(n, d)
    }
    ,
    l.noConflict = function() {
        return s._ = v,
        this
    }
    ,
    l.identity = function(n) {
        return n
    }
    ,
    l.times = function(n, d, y) {
        for (var P = Array(n), D = 0; n > D; D++)
            P[D] = d.call(y, D);
        return P
    }
    ,
    l.random = function(n, d) {
        return d == null && (d = n,
        n = 0),
        n + (0 | Math.random() * (d - n + 1))
    }
    ;
    var E = {
        escape: {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "/": "&#x2F;"
        }
    };
    E.unescape = l.invert(E.escape);
    var N = {
        escape: RegExp("[" + l.keys(E.escape).join("") + "]", "g"),
        unescape: RegExp("(" + l.keys(E.unescape).join("|") + ")", "g")
    };
    l.each(["escape", "unescape"], function(n) {
        l[n] = function(d) {
            return d == null ? "" : ("" + d).replace(N[n], function(y) {
                return E[n][y]
            })
        }
    }),
    l.result = function(n, d) {
        if (n == null)
            return null;
        var y = n[d];
        return l.isFunction(y) ? y.call(n) : y
    }
    ,
    l.mixin = function(n) {
        F(l.functions(n), function(d) {
            var y = l[d] = n[d];
            l.prototype[d] = function() {
                var P = [this._wrapped];
                return t.apply(P, arguments),
                W.call(this, y.apply(l, P))
            }
        })
    }
    ;
    var z = 0;
    l.uniqueId = function(n) {
        var d = "" + ++z;
        return n ? n + d : d
    }
    ,
    l.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
    };
    var H = /(.)^/
      , B = {
        "'": "'",
        "\\": "\\",
        "\r": "r",
        "\n": "n",
        " ": "t",
        "\u2028": "u2028",
        "\u2029": "u2029"
    }
      , X = /\\|'|\r|\n|\t|\u2028|\u2029/g;
    l.template = function(n, d, y) {
        y = l.defaults({}, y, l.templateSettings);
        var P = RegExp([(y.escape || H).source, (y.interpolate || H).source, (y.evaluate || H).source].join("|") + "|$", "g")
          , D = 0
          , O = "__p+='";
        n.replace(P, function(K, V, L, U, Z) {
            return O += n.slice(D, Z).replace(X, function(tt) {
                return "\\" + B[tt]
            }),
            V && (O += "'+\n((__t=(" + V + "))==null?'':_.escape(__t))+\n'"),
            L && (O += "'+\n((__t=(" + L + "))==null?'':__t)+\n'"),
            U && (O += "';\n" + U + "\n__p+='"),
            D = Z + K.length,
            K
        }),
        O += "';\n",
        y.variable || (O = "with(obj||{}){\n" + O + "}\n"),
        O = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + O + "return __p;\n";
        try {
            var M = Function(y.variable || "obj", "_", O)
        } catch (K) {
            throw K.source = O,
            K
        }
        if (d)
            return M(d, l);
        var R = function(K) {
            return M.call(this, K, l)
        };
        return R.source = "function(" + (y.variable || "obj") + "){\n" + O + "}",
        R
    }
    ,
    l.chain = function(n) {
        return l(n).chain()
    }
    ;
    var W = function(n) {
        return this._chain ? l(n).chain() : n
    };
    l.mixin(l),
    F(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function(n) {
        var d = a[n];
        l.prototype[n] = function() {
            var y = this._wrapped;
            return d.apply(y, arguments),
            n != "shift" && n != "splice" || y.length !== 0 || delete y[0],
            W.call(this, y)
        }
    }),
    F(["concat", "join", "slice"], function(n) {
        var d = a[n];
        l.prototype[n] = function() {
            return W.call(this, d.apply(this._wrapped, arguments))
        }
    }),
    l.extend(l.prototype, {
        chain: function() {
            return this._chain = !0,
            this
        },
        value: function() {
            return this._wrapped
        }
    })
}
).call(this),
function() {
    var s, v = this, g = v.Backbone, h = [], a = h.push, p = h.slice, u = h.splice;
    s = typeof exports == "undefined" ? v.Backbone = {} : exports,
    s.VERSION = "0.9.10";
    var t = v._;
    t || typeof require == "undefined" || (t = require("underscore")),
    s.$ = v.jQuery || v.Zepto || v.ender,
    s.noConflict = function() {
        return v.Backbone = g,
        this
    }
    ,
    s.emulateHTTP = !1,
    s.emulateJSON = !1;
    var e = /\s+/
      , r = function(i, c, m, S) {
        if (!m)
            return !0;
        if (typeof m == "object")
            for (var E in m)
                i[c].apply(i, [E, m[E]].concat(S));
        else if (e.test(m)) {
            m = m.split(e),
            E = 0;
            for (var N = m.length; E < N; E++)
                i[c].apply(i, [m[E]].concat(S))
        } else
            return !0
    }
      , o = function(i, c) {
        var m, S = -1, E = i.length;
        switch (c.length) {
        case 0:
            for (; ++S < E; )
                (m = i[S]).callback.call(m.ctx);
            break;
        case 1:
            for (; ++S < E; )
                (m = i[S]).callback.call(m.ctx, c[0]);
            break;
        case 2:
            for (; ++S < E; )
                (m = i[S]).callback.call(m.ctx, c[0], c[1]);
            break;
        case 3:
            for (; ++S < E; )
                (m = i[S]).callback.call(m.ctx, c[0], c[1], c[2]);
            break;
        default:
            for (; ++S < E; )
                (m = i[S]).callback.apply(m.ctx, c)
        }
    }
      , h = s.Events = {
        on: function(i, c, m) {
            return r(this, "on", i, [c, m]) && c ? (this._events || (this._events = {}),
            (this._events[i] || (this._events[i] = [])).push({
                callback: c,
                context: m,
                ctx: m || this
            }),
            this) : this
        },
        once: function(i, c, m) {
            if (!r(this, "once", i, [c, m]) || !c)
                return this;
            var S = this
              , E = t.once(function() {
                S.off(i, E),
                c.apply(this, arguments)
            });
            return E._callback = c,
            this.on(i, E, m),
            this
        },
        off: function(i, c, m) {
            var S, E, N, z, H, B, X, W;
            if (!this._events || !r(this, "off", i, [c, m]))
                return this;
            if (!i && !c && !m)
                return this._events = {},
                this;
            for (z = i ? [i] : t.keys(this._events),
            H = 0,
            B = z.length; H < B; H++)
                if (i = z[H],
                S = this._events[i]) {
                    if (N = [],
                    c || m)
                        for (X = 0,
                        W = S.length; X < W; X++)
                            E = S[X],
                            (c && c !== E.callback && c !== E.callback._callback || m && m !== E.context) && N.push(E);
                    this._events[i] = N
                }
            return this
        },
        trigger: function(i) {
            if (!this._events)
                return this;
            var c = p.call(arguments, 1);
            if (!r(this, "trigger", i, c))
                return this;
            var m = this._events[i]
              , S = this._events.all;
            return m && o(m, c),
            S && o(S, arguments),
            this
        },
        listenTo: function(i, c, m) {
            var S = this._listeners || (this._listeners = {})
              , E = i._listenerId || (i._listenerId = t.uniqueId("l"));
            return S[E] = i,
            i.on(c, typeof c == "object" ? this : m, this),
            this
        },
        stopListening: function(i, c, m) {
            var S = this._listeners;
            if (S) {
                if (i)
                    i.off(c, typeof c == "object" ? this : m, this),
                    c || m || delete S[i._listenerId];
                else {
                    for (var E in typeof c == "object" && (m = this),
                    S)
                        S[E].off(c, m, this);
                    this._listeners = {}
                }
                return this
            }
        }
    };
    h.bind = h.on,
    h.unbind = h.off,
    t.extend(s, h);
    var k = s.Model = function(i, c) {
        var m, S = i || {};
        this.cid = t.uniqueId("c"),
        this.attributes = {},
        c && c.collection && (this.collection = c.collection),
        c && c.parse && (S = this.parse(S, c) || {}),
        (m = t.result(this, "defaults")) && (S = t.defaults({}, S, m)),
        this.set(S, c),
        this.changed = {},
        this.initialize.apply(this, arguments)
    }
    ;
    t.extend(k.prototype, h, {
        changed: null,
        idAttribute: "id",
        initialize: function() {},
        toJSON: function() {
            return t.clone(this.attributes)
        },
        sync: function() {
            return s.sync.apply(this, arguments)
        },
        get: function(i) {
            return this.attributes[i]
        },
        escape: function(i) {
            return t.escape(this.get(i))
        },
        has: function(i) {
            return this.get(i) != null
        },
        set: function(i, c, m) {
            var S, E, N, z, H, B, X;
            if (i == null)
                return this;
            if (typeof i == "object" ? (E = i,
            m = c) : (E = {})[i] = c,
            m || (m = {}),
            !this._validate(E, m))
                return !1;
            for (S in N = m.unset,
            z = m.silent,
            i = [],
            H = this._changing,
            this._changing = !0,
            H || (this._previousAttributes = t.clone(this.attributes),
            this.changed = {}),
            X = this.attributes,
            B = this._previousAttributes,
            this.idAttribute in E && (this.id = E[this.idAttribute]),
            E)
                c = E[S],
                t.isEqual(X[S], c) || i.push(S),
                t.isEqual(B[S], c) ? delete this.changed[S] : this.changed[S] = c,
                N ? delete X[S] : X[S] = c;
            if (!z)
                for (i.length && (this._pending = !0),
                c = 0,
                S = i.length; c < S; c++)
                    this.trigger("change:" + i[c], this, X[i[c]], m);
            if (H)
                return this;
            if (!z)
                for (; this._pending; )
                    this._pending = !1,
                    this.trigger("change", this, m);
            return this._changing = this._pending = !1,
            this
        },
        unset: function(i, c) {
            return this.set(i, void 0, t.extend({}, c, {
                unset: !0
            }))
        },
        clear: function(i) {
            var c, m = {};
            for (c in this.attributes)
                m[c] = void 0;
            return this.set(m, t.extend({}, i, {
                unset: !0
            }))
        },
        hasChanged: function(i) {
            return i == null ? !t.isEmpty(this.changed) : t.has(this.changed, i)
        },
        changedAttributes: function(i) {
            if (!i)
                return !!this.hasChanged() && t.clone(this.changed);
            var c, m, S = !1, E = this._changing ? this._previousAttributes : this.attributes;
            for (m in i)
                t.isEqual(E[m], c = i[m]) || ((S || (S = {}))[m] = c);
            return S
        },
        previous: function(i) {
            return i != null && this._previousAttributes ? this._previousAttributes[i] : null
        },
        previousAttributes: function() {
            return t.clone(this._previousAttributes)
        },
        fetch: function(i) {
            i = i ? t.clone(i) : {},
            i.parse === void 0 && (i.parse = !0);
            var c = i.success;
            return i.success = function(m, S, E) {
                return !!m.set(m.parse(S, E), E) && void (c && c(m, S, E))
            }
            ,
            this.sync("read", this, i)
        },
        save: function(i, c, m) {
            var S, E, N = this.attributes;
            return i == null || typeof i == "object" ? (S = i,
            m = c) : (S = {})[i] = c,
            (!S || m && m.wait || this.set(S, m)) && (m = t.extend({
                validate: !0
            }, m),
            !!this._validate(S, m)) && (S && m.wait && (this.attributes = t.extend({}, N, S)),
            m.parse === void 0 && (m.parse = !0),
            E = m.success,
            m.success = function(z, H, B) {
                z.attributes = N;
                var X = z.parse(H, B);
                return B.wait && (X = t.extend(S || {}, X)),
                t.isObject(X) && !z.set(X, B) ? !1 : void (E && E(z, H, B))
            }
            ,
            i = this.isNew() ? "create" : m.patch ? "patch" : "update",
            i === "patch" && (m.attrs = S),
            i = this.sync(i, this, m),
            S && m.wait && (this.attributes = N),
            i)
        },
        destroy: function(i) {
            i = i ? t.clone(i) : {};
            var c = this
              , m = i.success
              , S = function() {
                c.trigger("destroy", c, c.collection, i)
            };
            if (i.success = function(N, z, H) {
                (H.wait || N.isNew()) && S(),
                m && m(N, z, H)
            }
            ,
            this.isNew())
                return i.success(this, null, i),
                !1;
            var E = this.sync("delete", this, i);
            return i.wait || S(),
            E
        },
        url: function() {
            var i = t.result(this, "urlRoot") || t.result(this.collection, "url") || Q();
            return this.isNew() ? i : i + (i.charAt(i.length - 1) === "/" ? "" : "/") + encodeURIComponent(this.id)
        },
        parse: function(i) {
            return i
        },
        clone: function() {
            return new this.constructor(this.attributes)
        },
        isNew: function() {
            return this.id == null
        },
        isValid: function(i) {
            return !this.validate || !this.validate(this.attributes, i)
        },
        _validate: function(i, c) {
            if (!c.validate || !this.validate)
                return !0;
            i = t.extend({}, this.attributes, i);
            var m = this.validationError = this.validate(i, c) || null;
            return !m || (this.trigger("invalid", this, m, c || {}),
            !1)
        }
    });
    var C = s.Collection = function(i, c) {
        c || (c = {}),
        c.model && (this.model = c.model),
        c.comparator !== void 0 && (this.comparator = c.comparator),
        this.models = [],
        this._reset(),
        this.initialize.apply(this, arguments),
        i && this.reset(i, t.extend({
            silent: !0
        }, c))
    }
    ;
    t.extend(C.prototype, h, {
        model: k,
        initialize: function() {},
        toJSON: function(i) {
            return this.map(function(c) {
                return c.toJSON(i)
            })
        },
        sync: function() {
            return s.sync.apply(this, arguments)
        },
        add: function(i, c) {
            i = t.isArray(i) ? i.slice() : [i],
            c || (c = {});
            var m, S, E, N, z, H, B, X, W, n;
            for (B = [],
            X = c.at,
            W = this.comparator && X == null && c.sort != !1,
            n = t.isString(this.comparator) ? this.comparator : null,
            m = 0,
            S = i.length; m < S; m++)
                (E = this._prepareModel(N = i[m], c)) ? (z = this.get(E)) ? c.merge && (z.set(N === E ? E.attributes : N, c),
                W && !H && z.hasChanged(n) && (H = !0)) : (B.push(E),
                E.on("all", this._onModelEvent, this),
                this._byId[E.cid] = E,
                E.id != null && (this._byId[E.id] = E)) : this.trigger("invalid", this, N, c);
            if (B.length && (W && (H = !0),
            this.length += B.length,
            X == null ? a.apply(this.models, B) : u.apply(this.models, [X, 0].concat(B))),
            H && this.sort({
                silent: !0
            }),
            c.silent)
                return this;
            for (m = 0,
            S = B.length; m < S; m++)
                (E = B[m]).trigger("add", E, this, c);
            return H && this.trigger("sort", this, c),
            this
        },
        remove: function(i, c) {
            i = t.isArray(i) ? i.slice() : [i],
            c || (c = {});
            var m, S, E, N;
            for (m = 0,
            S = i.length; m < S; m++)
                (N = this.get(i[m])) && (delete this._byId[N.id],
                delete this._byId[N.cid],
                E = this.indexOf(N),
                this.models.splice(E, 1),
                this.length--,
                c.silent || (c.index = E,
                N.trigger("remove", N, this, c)),
                this._removeReference(N));
            return this
        },
        push: function(i, c) {
            return i = this._prepareModel(i, c),
            this.add(i, t.extend({
                at: this.length
            }, c)),
            i
        },
        pop: function(i) {
            var c = this.at(this.length - 1);
            return this.remove(c, i),
            c
        },
        unshift: function(i, c) {
            return i = this._prepareModel(i, c),
            this.add(i, t.extend({
                at: 0
            }, c)),
            i
        },
        shift: function(i) {
            var c = this.at(0);
            return this.remove(c, i),
            c
        },
        slice: function(i, c) {
            return this.models.slice(i, c)
        },
        get: function(i) {
            if (i != null)
                return this._idAttr || (this._idAttr = this.model.prototype.idAttribute),
                this._byId[i.id || i.cid || i[this._idAttr] || i]
        },
        at: function(i) {
            return this.models[i]
        },
        where: function(i) {
            return t.isEmpty(i) ? [] : this.filter(function(c) {
                for (var m in i)
                    if (i[m] !== c.get(m))
                        return !1;
                return !0
            })
        },
        sort: function(i) {
            if (!this.comparator)
                throw Error("Cannot sort a set without a comparator");
            return i || (i = {}),
            t.isString(this.comparator) || this.comparator.length === 1 ? this.models = this.sortBy(this.comparator, this) : this.models.sort(t.bind(this.comparator, this)),
            i.silent || this.trigger("sort", this, i),
            this
        },
        pluck: function(i) {
            return t.invoke(this.models, "get", i)
        },
        update: function(i, c) {
            c = t.extend({
                add: !0,
                merge: !0,
                remove: !0
            }, c),
            c.parse && (i = this.parse(i, c));
            var m, S, E, N, z = [], H = [], B = {};
            if (t.isArray(i) || (i = i ? [i] : []),
            c.add && !c.remove)
                return this.add(i, c);
            for (S = 0,
            E = i.length; S < E; S++)
                m = i[S],
                N = this.get(m),
                c.remove && N && (B[N.cid] = !0),
                (c.add && !N || c.merge && N) && z.push(m);
            if (c.remove)
                for (S = 0,
                E = this.models.length; S < E; S++)
                    m = this.models[S],
                    B[m.cid] || H.push(m);
            return H.length && this.remove(H, c),
            z.length && this.add(z, c),
            this
        },
        reset: function(i, c) {
            c || (c = {}),
            c.parse && (i = this.parse(i, c));
            for (var m = 0, S = this.models.length; m < S; m++)
                this._removeReference(this.models[m]);
            return c.previousModels = this.models.slice(),
            this._reset(),
            i && this.add(i, t.extend({
                silent: !0
            }, c)),
            c.silent || this.trigger("reset", this, c),
            this
        },
        fetch: function(i) {
            i = i ? t.clone(i) : {},
            i.parse === void 0 && (i.parse = !0);
            var c = i.success;
            return i.success = function(m, S, E) {
                m[E.update ? "update" : "reset"](S, E),
                c && c(m, S, E)
            }
            ,
            this.sync("read", this, i)
        },
        create: function(i, c) {
            if (c = c ? t.clone(c) : {},
            !(i = this._prepareModel(i, c)))
                return !1;
            c.wait || this.add(i, c);
            var m = this
              , S = c.success;
            return c.success = function(E, N, z) {
                z.wait && m.add(E, z),
                S && S(E, N, z)
            }
            ,
            i.save(null, c),
            i
        },
        parse: function(i) {
            return i
        },
        clone: function() {
            return new this.constructor(this.models)
        },
        _reset: function() {
            this.length = 0,
            this.models.length = 0,
            this._byId = {}
        },
        _prepareModel: function(i, c) {
            if (i instanceof k)
                return i.collection || (i.collection = this),
                i;
            c || (c = {}),
            c.collection = this;
            var m = new this.model(i,c);
            return !!m._validate(i, c) && m
        },
        _removeReference: function(i) {
            this === i.collection && delete i.collection,
            i.off("all", this._onModelEvent, this)
        },
        _onModelEvent: function(i, c, m, S) {
            (i === "add" || i === "remove") && m !== this || (i === "destroy" && this.remove(c, S),
            c && i === "change:" + c.idAttribute && (delete this._byId[c.previous(c.idAttribute)],
            c.id != null && (this._byId[c.id] = c)),
            this.trigger.apply(this, arguments))
        },
        sortedIndex: function(i, c, m) {
            c || (c = this.comparator);
            var S = t.isFunction(c) ? c : function(E) {
                return E.get(c)
            }
            ;
            return t.sortedIndex(this.models, i, S, m)
        }
    }),
    t.each("forEach each map collect reduce foldl inject reduceRight foldr find detect filter select reject every all some any include contains invoke max min toArray size first head take initial rest tail drop last without indexOf shuffle lastIndexOf isEmpty chain".split(" "), function(i) {
        C.prototype[i] = function() {
            var c = p.call(arguments);
            return c.unshift(this.models),
            t[i].apply(t, c)
        }
    }),
    t.each(["groupBy", "countBy", "sortBy"], function(i) {
        C.prototype[i] = function(c, m) {
            var S = t.isFunction(c) ? c : function(E) {
                return E.get(c)
            }
            ;
            return t[i](this.models, S, m)
        }
    });
    var w = s.Router = function(i) {
        i || (i = {}),
        i.routes && (this.routes = i.routes),
        this._bindRoutes(),
        this.initialize.apply(this, arguments)
    }
      , b = /\((.*?)\)/g
      , A = /(\(\?)?:\w+/g
      , _ = /\*\w+/g
      , x = /[\-{}\[\]+?.,\\\^$|#\s]/g;
    t.extend(w.prototype, h, {
        initialize: function() {},
        route: function(i, c, m) {
            return t.isRegExp(i) || (i = this._routeToRegExp(i)),
            m || (m = this[c]),
            s.history.route(i, t.bind(function(S) {
                S = this._extractParameters(i, S),
                m && m.apply(this, S),
                this.trigger.apply(this, ["route:" + c].concat(S)),
                this.trigger("route", c, S),
                s.history.trigger("route", this, c, S)
            }, this)),
            this
        },
        navigate: function(i, c) {
            return s.history.navigate(i, c),
            this
        },
        _bindRoutes: function() {
            if (this.routes)
                for (var i, c = t.keys(this.routes); (i = c.pop()) != null; )
                    this.route(i, this.routes[i])
        },
        _routeToRegExp: function(i) {
            return i = i.replace(x, "\\$&").replace(b, "(?:$1)?").replace(A, function(c, m) {
                return m ? c : "([^/]+)"
            }).replace(_, "(.*?)"),
            RegExp("^" + i + "$")
        },
        _extractParameters: function(i, c) {
            return i.exec(c).slice(1)
        }
    });
    var T = s.History = function() {
        this.handlers = [],
        t.bindAll(this, "checkUrl"),
        typeof window != "undefined" && (this.location = window.location,
        this.history = window.history)
    }
      , I = /^[#\/]|\s+$/g
      , q = /^\/+|\/+$/g
      , $ = /msie [\w.]+/
      , Y = /\/$/;
    T.started = !1,
    t.extend(T.prototype, h, {
        interval: 50,
        getHash: function(i) {
            return (i = (i || this).location.href.match(/#(.*)$/)) ? i[1] : ""
        },
        getFragment: function(i, c) {
            if (i == null)
                if (this._hasPushState || !this._wantsHashChange || c) {
                    i = this.location.pathname;
                    var m = this.root.replace(Y, "");
                    i.indexOf(m) || (i = i.substr(m.length))
                } else
                    i = this.getHash();
            return i.replace(I, "")
        },
        start: function(i) {
            if (T.started)
                throw Error("Backbone.history has already been started");
            T.started = !0,
            this.options = t.extend({}, {
                root: "/"
            }, this.options, i),
            this.root = this.options.root,
            this._wantsHashChange = this.options.hashChange !== !1,
            this._wantsPushState = !!this.options.pushState,
            this._hasPushState = this.options.pushState && this.history && this.history.pushState,
            i = this.getFragment();
            var c = document.documentMode
              , c = $.exec(navigator.userAgent.toLowerCase()) && (!c || 7 >= c);
            return this.root = ("/" + this.root + "/").replace(q, "/"),
            c && this._wantsHashChange && (this.iframe = s.$('<iframe src="javascript:0" tabindex="-1" />').hide().appendTo("body")[0].contentWindow,
            this.navigate(i)),
            this._hasPushState ? s.$(window).on("popstate", this.checkUrl) : this._wantsHashChange && "onhashchange"in window && !c ? s.$(window).on("hashchange", this.checkUrl) : this._wantsHashChange && (this._checkUrlInterval = setInterval(this.checkUrl, this.interval)),
            this.fragment = i,
            i = this.location,
            c = i.pathname.replace(/[^\/]$/, "$&/") === this.root,
            this._wantsHashChange && this._wantsPushState && !this._hasPushState && !c ? (this.fragment = this.getFragment(null, !0),
            this.location.replace(this.root + this.location.search + "#" + this.fragment),
            !0) : (this._wantsPushState && this._hasPushState && c && i.hash && (this.fragment = this.getHash().replace(I, ""),
            this.history.replaceState({}, document.title, this.root + this.fragment + i.search)),
            this.options.silent ? void 0 : this.loadUrl())
        },
        stop: function() {
            s.$(window).off("popstate", this.checkUrl).off("hashchange", this.checkUrl),
            clearInterval(this._checkUrlInterval),
            T.started = !1
        },
        route: function(i, c) {
            this.handlers.unshift({
                route: i,
                callback: c
            })
        },
        checkUrl: function() {
            var i = this.getFragment();
            return i === this.fragment && this.iframe && (i = this.getFragment(this.getHash(this.iframe))),
            i !== this.fragment && (this.iframe && this.navigate(i),
            void (this.loadUrl() || this.loadUrl(this.getHash())))
        },
        loadUrl: function(i) {
            var c = this.fragment = this.getFragment(i);
            return t.any(this.handlers, function(m) {
                if (m.route.test(c))
                    return m.callback(c),
                    !0
            })
        },
        navigate: function(i, c) {
            if (!T.started)
                return !1;
            if (c && c !== !0 || (c = {
                trigger: c
            }),
            i = this.getFragment(i || ""),
            this.fragment !== i) {
                this.fragment = i;
                var m = this.root + i;
                if (this._hasPushState)
                    this.history[c.replace ? "replaceState" : "pushState"]({}, document.title, m);
                else if (this._wantsHashChange)
                    this._updateHash(this.location, i, c.replace),
                    this.iframe && i !== this.getFragment(this.getHash(this.iframe)) && (c.replace || this.iframe.document.open().close(),
                    this._updateHash(this.iframe.location, i, c.replace));
                else
                    return this.location.assign(m);
                c.trigger && this.loadUrl(i)
            }
        },
        _updateHash: function(i, c, m) {
            m ? (m = i.href.replace(/(javascript:|#).*$/, ""),
            i.replace(m + "#" + c)) : i.hash = "#" + c
        }
    }),
    s.history = new T;
    var l = s.View = function(i) {
        this.cid = t.uniqueId("view"),
        this._configure(i || {}),
        this._ensureElement(),
        this.initialize.apply(this, arguments),
        this.delegateEvents()
    }
      , F = /^(\S+)\s*(.*)$/
      , J = "model collection el id attributes className tagName events".split(" ");
    t.extend(l.prototype, h, {
        tagName: "div",
        $: function(i) {
            return this.$el.find(i)
        },
        initialize: function() {},
        render: function() {
            return this
        },
        remove: function() {
            return this.$el.remove(),
            this.stopListening(),
            this
        },
        setElement: function(i, c) {
            return this.$el && this.undelegateEvents(),
            this.$el = i instanceof s.$ ? i : s.$(i),
            this.el = this.$el[0],
            c !== !1 && this.delegateEvents(),
            this
        },
        delegateEvents: function(i) {
            if (i || (i = t.result(this, "events")))
                for (var c in this.undelegateEvents(),
                i) {
                    var S = i[c];
                    if (t.isFunction(S) || (S = this[i[c]]),
                    !S)
                        throw Error('Method "' + i[c] + '" does not exist');
                    var m = c.match(F)
                      , E = m[1]
                      , m = m[2]
                      , S = t.bind(S, this)
                      , E = E + (".delegateEvents" + this.cid);
                    m === "" ? this.$el.on(E, S) : this.$el.on(E, m, S)
                }
        },
        undelegateEvents: function() {
            this.$el.off(".delegateEvents" + this.cid)
        },
        _configure: function(i) {
            this.options && (i = t.extend({}, t.result(this, "options"), i)),
            t.extend(this, t.pick(i, J)),
            this.options = i
        },
        _ensureElement: function() {
            if (this.el)
                this.setElement(t.result(this, "el"), !1);
            else {
                var i = t.extend({}, t.result(this, "attributes"));
                this.id && (i.id = t.result(this, "id")),
                this.className && (i.class = t.result(this, "className")),
                i = s.$("<" + t.result(this, "tagName") + ">").attr(i),
                this.setElement(i, !1)
            }
        }
    });
    var G = {
        create: "POST",
        update: "PUT",
        patch: "PATCH",
        delete: "DELETE",
        read: "GET"
    };
    s.sync = function(i, c, m) {
        var S = G[i];
        t.defaults(m || (m = {}), {
            emulateHTTP: s.emulateHTTP,
            emulateJSON: s.emulateJSON
        });
        var E = {
            type: S,
            dataType: "json"
        };
        if (m.url || (E.url = t.result(c, "url") || Q()),
        m.data == null && c && (i === "create" || i === "update" || i === "patch") && (E.contentType = "application/json",
        E.data = JSON.stringify(m.attrs || c.toJSON(m))),
        m.emulateJSON && (E.contentType = "application/x-www-form-urlencoded",
        E.data = E.data ? {
            model: E.data
        } : {}),
        m.emulateHTTP && (S === "PUT" || S === "DELETE" || S === "PATCH")) {
            E.type = "POST",
            m.emulateJSON && (E.data._method = S);
            var N = m.beforeSend;
            m.beforeSend = function(B) {
                if (B.setRequestHeader("X-HTTP-Method-Override", S),
                N)
                    return N.apply(this, arguments)
            }
        }
        E.type === "GET" || m.emulateJSON || (E.processData = !1);
        var z = m.success;
        m.success = function(B) {
            z && z(c, B, m),
            c.trigger("sync", c, B, m)
        }
        ;
        var H = m.error;
        return m.error = function(B) {
            H && H(c, B, m),
            c.trigger("error", c, B, m)
        }
        ,
        i = m.xhr = s.ajax(t.extend(E, m)),
        c.trigger("request", c, i, m),
        i
    }
    ,
    s.ajax = function() {
        return s.$.ajax.apply(s.$, arguments)
    }
    ,
    k.extend = C.extend = w.extend = l.extend = T.extend = function(i, c) {
        var m, S = this;
        m = i && t.has(i, "constructor") ? i.constructor : function() {
            return S.apply(this, arguments)
        }
        ,
        t.extend(m, S, c);
        var E = function() {
            this.constructor = m
        };
        return E.prototype = S.prototype,
        m.prototype = new E,
        i && t.extend(m.prototype, i),
        m.__super__ = S.prototype,
        m
    }
    ;
    var Q = function() {
        throw Error('A "url" property or function must be specified')
    }
}
.call(this),
function(s, v) {
    typeof define == "function" && define.amd ? define([], v) : typeof exports == "object" ? module.exports = v() : v()
}(this, function() {
    function s(l) {
        if (A === null) {
            for (var F = l.length, J = 0, G = document.getElementById(u), Q = "<ul>"; J < F; )
                Q += "<li>" + l[J] + "</li>",
                J++;
            G.innerHTML = Q + "</ul>"
        } else
            A(l)
    }
    function v(l) {
        return l.replace(/<b[^>]*>(.*?)<\/b>/gi, function(F, J) {
            return J
        }).replace(/class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi, "")
    }
    function g(l) {
        l = l.getElementsByTagName("a");
        for (var F = l.length - 1; 0 <= F; F--)
            l[F].setAttribute("target", "_blank")
    }
    function a(l, F) {
        for (var J = [], G = new RegExp("(^| )" + F + "( |$)"), Q = l.getElementsByTagName("*"), i = 0, c = Q.length; i < c; i++)
            G.test(Q[i].className) && J.push(Q[i]);
        return J
    }
    function p(l) {
        if (l !== void 0 && 0 <= l.innerHTML.indexOf("data-srcset"))
            return l = l.innerHTML.match(/data-srcset="([A-z0-9%_\.-]+)/i)[0],
            decodeURIComponent(l).split('"')[1]
    }
    var u = ""
      , t = 20
      , e = !0
      , r = []
      , o = !1
      , h = !0
      , k = !0
      , C = null
      , w = !0
      , b = !0
      , A = null
      , _ = !0
      , x = !1
      , T = !0
      , I = !0
      , q = !1
      , $ = null
      , Y = {
        fetch: function(l) {
            if (l.maxTweets === void 0 && (l.maxTweets = 20),
            l.enableLinks === void 0 && (l.enableLinks = !0),
            l.showUser === void 0 && (l.showUser = !0),
            l.showTime === void 0 && (l.showTime = !0),
            l.dateFunction === void 0 && (l.dateFunction = "default"),
            l.showRetweet === void 0 && (l.showRetweet = !0),
            l.customCallback === void 0 && (l.customCallback = null),
            l.showInteraction === void 0 && (l.showInteraction = !0),
            l.showImages === void 0 && (l.showImages = !1),
            l.linksInNewWindow === void 0 && (l.linksInNewWindow = !0),
            l.showPermalinks === void 0 && (l.showPermalinks = !0),
            l.dataOnly === void 0 && (l.dataOnly = !1),
            o)
                r.push(l);
            else {
                o = !0,
                u = l.domId,
                t = l.maxTweets,
                e = l.enableLinks,
                k = l.showUser,
                h = l.showTime,
                b = l.showRetweet,
                C = l.dateFunction,
                A = l.customCallback,
                _ = l.showInteraction,
                x = l.showImages,
                T = l.linksInNewWindow,
                I = l.showPermalinks,
                q = l.dataOnly;
                var F = document.getElementsByTagName("head")[0];
                $ != null && F.removeChild($),
                $ = document.createElement("script"),
                $.type = "text/javascript",
                $.src = l.list === void 0 ? l.profile === void 0 ? l.likes === void 0 ? "https://cdn.syndication.twimg.com/widgets/timelines/" + l.id + "?&lang=" + (l.lang || "en") + "&callback=twitterFetcher.callback&suppress_response_codes=true&rnd=" + Math.random() : "https://syndication.twitter.com/timeline/likes?callback=twitterFetcher.callback&dnt=false&screen_name=" + l.likes.screenName + "&suppress_response_codes=true&lang=" + (l.lang || "en") + "&rnd=" + Math.random() : "https://syndication.twitter.com/timeline/profile?callback=twitterFetcher.callback&dnt=false&screen_name=" + l.profile.screenName + "&suppress_response_codes=true&lang=" + (l.lang || "en") + "&rnd=" + Math.random() : "https://syndication.twitter.com/timeline/list?callback=twitterFetcher.callback&dnt=false&list_slug=" + l.list.listSlug + "&screen_name=" + l.list.screenName + "&suppress_response_codes=true&lang=" + (l.lang || "en") + "&rnd=" + Math.random(),
                F.appendChild($)
            }
        },
        callback: function(l) {
            function F(B) {
                var X = B.getElementsByTagName("img")[0];
                return X.src = X.getAttribute("data-src-2x"),
                B
            }
            var S = document.createElement("div");
            S.innerHTML = l.body,
            typeof S.getElementsByClassName == "undefined" && (w = !1),
            l = [];
            var J = []
              , G = []
              , Q = []
              , i = []
              , c = []
              , m = []
              , E = 0;
            if (w)
                for (S = S.getElementsByClassName("timeline-Tweet"); E < S.length; )
                    0 < S[E].getElementsByClassName("timeline-Tweet-retweetCredit").length ? i.push(!0) : i.push(!1),
                    (!i[E] || i[E] && b) && (l.push(S[E].getElementsByClassName("timeline-Tweet-text")[0]),
                    c.push(S[E].getAttribute("data-tweet-id")),
                    J.push(F(S[E].getElementsByClassName("timeline-Tweet-author")[0])),
                    G.push(S[E].getElementsByClassName("dt-updated")[0]),
                    m.push(S[E].getElementsByClassName("timeline-Tweet-timestamp")[0]),
                    S[E].getElementsByClassName("timeline-Tweet-media")[0] === void 0 ? Q.push(void 0) : Q.push(S[E].getElementsByClassName("timeline-Tweet-media")[0])),
                    E++;
            else
                for (S = a(S, "timeline-Tweet"); E < S.length; )
                    0 < a(S[E], "timeline-Tweet-retweetCredit").length ? i.push(!0) : i.push(!1),
                    (!i[E] || i[E] && b) && (l.push(a(S[E], "timeline-Tweet-text")[0]),
                    c.push(S[E].getAttribute("data-tweet-id")),
                    J.push(F(a(S[E], "timeline-Tweet-author")[0])),
                    G.push(a(S[E], "dt-updated")[0]),
                    m.push(a(S[E], "timeline-Tweet-timestamp")[0]),
                    a(S[E], "timeline-Tweet-media")[0] === void 0 ? Q.push(void 0) : Q.push(a(S[E], "timeline-Tweet-media")[0])),
                    E++;
            l.length > t && (l.splice(t, l.length - t),
            J.splice(t, J.length - t),
            G.splice(t, G.length - t),
            i.splice(t, i.length - t),
            Q.splice(t, Q.length - t),
            m.splice(t, m.length - t));
            var S = []
              , E = l.length
              , N = 0;
            if (q)
                for (; N < E; )
                    S.push({
                        tweet: l[N].innerHTML,
                        author: J[N].innerHTML,
                        time: G[N].textContent,
                        image: p(Q[N]),
                        rt: i[N],
                        tid: c[N],
                        permalinkURL: m[N] === void 0 ? "" : m[N].href
                    }),
                    N++;
            else
                for (; N < E; ) {
                    if (typeof C != "string") {
                        var i = G[N].getAttribute("datetime")
                          , z = new Date(G[N].getAttribute("datetime").replace(/-/g, "/").replace("T", " ").split("+")[0])
                          , i = C(z, i);
                        if (G[N].setAttribute("aria-label", i),
                        !l[N].textContent)
                            G[N].textContent = i;
                        else if (w)
                            G[N].textContent = i;
                        else {
                            var z = document.createElement("p")
                              , H = document.createTextNode(i);
                            z.appendChild(H),
                            z.setAttribute("aria-label", i),
                            G[N] = z
                        }
                    }
                    i = "",
                    e ? (T && (g(l[N]),
                    k && g(J[N])),
                    k && (i += '<div class="user">' + v(J[N].innerHTML) + "</div>"),
                    i += '<p class="tweet">' + v(l[N].innerHTML) + "</p>",
                    h && (i = I ? i + ('<p class="timePosted"><a href="' + m[N] + '">' + G[N].getAttribute("aria-label") + "</a></p>") : i + ('<p class="timePosted">' + G[N].getAttribute("aria-label") + "</p>"))) : (k && (i += '<p class="user">' + J[N].textContent + "</p>"),
                    i += '<p class="tweet">' + l[N].textContent + "</p>",
                    h && (i += '<p class="timePosted">' + G[N].textContent + "</p>")),
                    _ && (i += '<p class="interact"><a href="https://twitter.com/intent/tweet?in_reply_to=' + c[N] + '" class="twitter_reply_icon"' + (T ? ' target="_blank">' : ">") + 'Reply</a><a href="https://twitter.com/intent/retweet?tweet_id=' + c[N] + '" class="twitter_retweet_icon"' + (T ? ' target="_blank">' : ">") + 'Retweet</a><a href="https://twitter.com/intent/favorite?tweet_id=' + c[N] + '" class="twitter_fav_icon"' + (T ? ' target="_blank">' : ">") + "Favorite</a></p>"),
                    x && Q[N] !== void 0 && (i += '<div class="media"><img src="' + p(Q[N]) + '" alt="Image from tweet" /></div>'),
                    S.push(i),
                    N++
                }
            s(S),
            o = !1,
            0 < r.length && (Y.fetch(r[0]),
            r.splice(0, 1))
        }
    };
    return window.twitterFetcher = Y
});
var JSON;
JSON || (JSON = {}),
function() {
    function f(s) {
        return 10 > s ? "0" + s : s
    }
    function quote(s) {
        return escapable.lastIndex = 0,
        escapable.test(s) ? '"' + s.replace(escapable, function(v) {
            var g = meta[v];
            return typeof g == "string" ? g : "\\u" + ("0000" + v.charCodeAt(0).toString(16)).slice(-4)
        }) + '"' : '"' + s + '"'
    }
    function str(s, v) {
        var g, a, p, u, t, e = gap, r = v[s];
        switch (r && typeof r == "object" && typeof r.toJSON == "function" && (r = r.toJSON(s)),
        typeof rep == "function" && (r = rep.call(v, s, r)),
        typeof r) {
        case "string":
            return quote(r);
        case "number":
            return isFinite(r) ? r + "" : "null";
        case "boolean":
        case "null":
            return r + "";
        case "object":
            if (!r)
                return "null";
            if (gap += indent,
            t = [],
            Object.prototype.toString.apply(r) === "[object Array]") {
                for (u = r.length,
                g = 0; g < u; g += 1)
                    t[g] = str(g, r) || "null";
                return p = t.length === 0 ? "[]" : gap ? "[\n" + gap + t.join(",\n" + gap) + "\n" + e + "]" : "[" + t.join(",") + "]",
                gap = e,
                p
            }
            if (rep && typeof rep == "object")
                for (u = rep.length,
                g = 0; g < u; g += 1)
                    typeof rep[g] == "string" && (a = rep[g],
                    p = str(a, r),
                    p && t.push(quote(a) + (gap ? ": " : ":") + p));
            else
                for (a in r)
                    Object.prototype.hasOwnProperty.call(r, a) && (p = str(a, r),
                    p && t.push(quote(a) + (gap ? ": " : ":") + p));
            return p = t.length === 0 ? "{}" : gap ? "{\n" + gap + t.join(",\n" + gap) + "\n" + e + "}" : "{" + t.join(",") + "}",
            gap = e,
            p
        }
    }
    typeof Date.prototype.toJSON != "function" && (Date.prototype.toJSON = function() {
        return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null
    }
    ,
    String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function() {
        return this.valueOf()
    }
    );
    var gap, indent, rep, cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, meta = {
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
    };
    typeof JSON.stringify != "function" && (JSON.stringify = function(s, v, g) {
        var a;
        if (gap = "",
        indent = "",
        typeof g == "number")
            for (a = 0; a < g; a += 1)
                indent += " ";
        else
            typeof g == "string" && (indent = g);
        if (rep = v,
        v && typeof v != "function" && (typeof v != "object" || typeof v.length != "number"))
            throw new Error("JSON.stringify");
        return str("", {
            "": s
        })
    }
    ),
    typeof JSON.parse != "function" && (JSON.parse = function(text, reviver) {
        function walk(s, v) {
            var g, a, p = s[v];
            if (p && typeof p == "object")
                for (g in p)
                    Object.prototype.hasOwnProperty.call(p, g) && (a = walk(p, g),
                    a == null ? delete p[g] : p[g] = a);
            return reviver.call(s, v, p)
        }
        var j;
        if (text += "",
        cx.lastIndex = 0,
        cx.test(text) && (text = text.replace(cx, function(s) {
            return "\\u" + ("0000" + s.charCodeAt(0).toString(16)).slice(-4)
        })),
        /^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:\s*\[)+/g, "")))
            return j = eval("(" + text + ")"),
            typeof reviver == "function" ? walk({
                "": j
            }, "") : j;
        throw new SyntaxError("JSON.parse")
    }
    )
}(),
function(s) {
    "use strict";
    s.fn.fitVids = function(v) {
        var g = {
            customSelector: null
        };
        return v && s.extend(g, v),
        this.each(function() {
            var a = ["iframe:not([src*='soundcloud.com'])", "object", "embed"];
            g.customSelector && a.push(g.customSelector);
            var p = s(this).find(a.join(","));
            p = p.not("object object"),
            p.each(function() {
                var u = s(this);
                if (!(this.tagName.toLowerCase() === "embed" && u.parent("object").length || u.parent(".fluid-width-video-wrapper").length)) {
                    var t = this.tagName.toLowerCase() === "object" || u.attr("height") && !isNaN(parseInt(u.attr("height"), 10)) ? parseInt(u.attr("height"), 10) : u.height()
                      , e = isNaN(parseInt(u.attr("width"), 10)) ? u.width() : parseInt(u.attr("width"), 10);
                    if (!u.attr("id")) {
                        var r = "fitvid" + Math.floor(999999 * Math.random());
                        u.attr("id", r)
                    }
                    u.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top", 100 * (t / e) + "%"),
                    u.hasClass("highlight") || s(document.body).hasClass("template-index") || u.parent(".fluid-width-video-wrapper").wrap('<div class="max-width-video-wrapper"></div>').parent(".max-width-video-wrapper").css({
                        maxWidth: 640,
                        marginLeft: "auto",
                        marginRight: "auto"
                    }),
                    u.removeAttr("height").removeAttr("width")
                }
            })
        })
    }
}(window.jQuery || window.Zepto),
function() {
    function s() {}
    function v(t, e) {
        for (var r = t.length; r--; )
            if (t[r].listener === e)
                return r;
        return -1
    }
    function g(t) {
        return function() {
            return this[t].apply(this, arguments)
        }
    }
    var a = s.prototype
      , p = this
      , u = p.EventEmitter;
    a.getListeners = function(t) {
        var e, r, o = this._getEvents();
        if (typeof t == "object")
            for (r in e = {},
            o)
                o.hasOwnProperty(r) && t.test(r) && (e[r] = o[r]);
        else
            e = o[t] || (o[t] = []);
        return e
    }
    ,
    a.flattenListeners = function(t) {
        var e, r = [];
        for (e = 0; t.length > e; e += 1)
            r.push(t[e].listener);
        return r
    }
    ,
    a.getListenersAsObject = function(t) {
        var e, r = this.getListeners(t);
        return r instanceof Array && (e = {},
        e[t] = r),
        e || r
    }
    ,
    a.addListener = function(t, e) {
        var r, o = this.getListenersAsObject(t);
        for (r in o)
            o.hasOwnProperty(r) && v(o[r], e) === -1 && o[r].push(typeof e == "object" ? e : {
                listener: e,
                once: !1
            });
        return this
    }
    ,
    a.on = g("addListener"),
    a.addOnceListener = function(t, e) {
        return this.addListener(t, {
            listener: e,
            once: !0
        })
    }
    ,
    a.once = g("addOnceListener"),
    a.defineEvent = function(t) {
        return this.getListeners(t),
        this
    }
    ,
    a.defineEvents = function(t) {
        for (var e = 0; t.length > e; e += 1)
            this.defineEvent(t[e]);
        return this
    }
    ,
    a.removeListener = function(t, e) {
        var r, o, h = this.getListenersAsObject(t);
        for (o in h)
            h.hasOwnProperty(o) && (r = v(h[o], e),
            r !== -1 && h[o].splice(r, 1));
        return this
    }
    ,
    a.off = g("removeListener"),
    a.addListeners = function(t, e) {
        return this.manipulateListeners(!1, t, e)
    }
    ,
    a.removeListeners = function(t, e) {
        return this.manipulateListeners(!0, t, e)
    }
    ,
    a.manipulateListeners = function(t, e, r) {
        var o, h, k = t ? this.removeListener : this.addListener, C = t ? this.removeListeners : this.addListeners;
        if (typeof e != "object" || e instanceof RegExp)
            for (o = r.length; o--; )
                k.call(this, e, r[o]);
        else
            for (o in e)
                e.hasOwnProperty(o) && (h = e[o]) && (typeof h == "function" ? k.call(this, o, h) : C.call(this, o, h));
        return this
    }
    ,
    a.removeEvent = function(t) {
        var e, r = typeof t, o = this._getEvents();
        if (r == "string")
            delete o[t];
        else if (r == "object")
            for (e in o)
                o.hasOwnProperty(e) && t.test(e) && delete o[e];
        else
            delete this._events;
        return this
    }
    ,
    a.removeAllListeners = g("removeEvent"),
    a.emitEvent = function(t, e) {
        var r, o, h, k, C = this.getListenersAsObject(t);
        for (h in C)
            if (C.hasOwnProperty(h))
                for (o = C[h].length; o--; )
                    r = C[h][o],
                    r.once === !0 && this.removeListener(t, r.listener),
                    k = r.listener.apply(this, e || []),
                    k === this._getOnceReturnValue() && this.removeListener(t, r.listener);
        return this
    }
    ,
    a.trigger = g("emitEvent"),
    a.emit = function(t) {
        var e = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(t, e)
    }
    ,
    a.setOnceReturnValue = function(t) {
        return this._onceReturnValue = t,
        this
    }
    ,
    a._getOnceReturnValue = function() {
        return !this.hasOwnProperty("_onceReturnValue") || this._onceReturnValue
    }
    ,
    a._getEvents = function() {
        return this._events || (this._events = {})
    }
    ,
    s.noConflict = function() {
        return p.EventEmitter = u,
        s
    }
    ,
    typeof define == "function" && define.amd ? define("eventEmitter/EventEmitter", [], function() {
        return s
    }) : typeof module == "object" && module.exports ? module.exports = s : this.EventEmitter = s
}
.call(this),
function(s) {
    function v(t) {
        var e = s.event;
        return e.target = e.target || e.srcElement || t,
        e
    }
    var g = document.documentElement
      , a = function() {};
    g.addEventListener ? a = function(t, e, r) {
        t.addEventListener(e, r, !1)
    }
    : g.attachEvent && (a = function(t, e, r) {
        t[e + r] = r.handleEvent ? function() {
            var o = v(t);
            r.handleEvent.call(r, o)
        }
        : function() {
            var o = v(t);
            r.call(t, o)
        }
        ,
        t.attachEvent("on" + e, t[e + r])
    }
    );
    var p = function() {};
    g.removeEventListener ? p = function(t, e, r) {
        t.removeEventListener(e, r, !1)
    }
    : g.detachEvent && (p = function(t, e, r) {
        t.detachEvent("on" + e, t[e + r]);
        try {
            delete t[e + r]
        } catch (o) {
            t[e + r] = void 0
        }
    }
    );
    var u = {
        bind: a,
        unbind: p
    };
    typeof define == "function" && define.amd ? define("eventie/eventie", u) : s.eventie = u
}(this),
function(s, v) {
    typeof define == "function" && define.amd ? define(["eventEmitter/EventEmitter", "eventie/eventie"], function(g, a) {
        return v(s, g, a)
    }) : typeof exports == "object" ? module.exports = v(s, require("eventEmitter"), require("eventie")) : s.imagesLoaded = v(s, s.EventEmitter, s.eventie)
}(this, function(s, v, g) {
    function a(w, b) {
        for (var A in b)
            w[A] = b[A];
        return w
    }
    function p(w) {
        return k.call(w) === "[object Array]"
    }
    function u(w) {
        var b = [];
        if (p(w))
            b = w;
        else if (typeof w.length == "number")
            for (var A = 0, _ = w.length; _ > A; A++)
                b.push(w[A]);
        else
            b.push(w);
        return b
    }
    function t(w, b, A) {
        if (!(this instanceof t))
            return new t(w,b);
        typeof w == "string" && (w = document.querySelectorAll(w)),
        this.elements = u(w),
        this.options = a({}, this.options),
        typeof b == "function" ? A = b : a(this.options, b),
        A && this.on("always", A),
        this.getImages(),
        o && (this.jqDeferred = new o.Deferred);
        var _ = this;
        setTimeout(function() {
            _.check()
        })
    }
    function e(w) {
        this.img = w
    }
    function r(w) {
        this.src = w,
        C[w] = this
    }
    var o = s.jQuery
      , h = s.console
      , k = Object.prototype.toString;
    t.prototype = new v,
    t.prototype.options = {},
    t.prototype.getImages = function() {
        this.images = [];
        for (var w, b = 0, A = this.elements.length; A > b; b++) {
            w = this.elements[b],
            w.nodeName === "IMG" && this.addImage(w);
            for (var _, x = w.querySelectorAll("img"), T = 0, I = x.length; I > T; T++)
                _ = x[T],
                this.addImage(_)
        }
    }
    ,
    t.prototype.addImage = function(w) {
        var b = new e(w);
        this.images.push(b)
    }
    ,
    t.prototype.check = function() {
        function w(I, q) {
            return b.options.debug && h !== void 0 && h.log("confirm", I, q),
            b.progress(I),
            A++,
            A === _ && b.complete(),
            !0
        }
        var b = this
          , A = 0
          , _ = this.images.length;
        if (this.hasAnyBroken = !1,
        !_)
            return this.complete(),
            void 0;
        for (var x, T = 0; _ > T; T++)
            x = this.images[T],
            x.on("confirm", w),
            x.check()
    }
    ,
    t.prototype.progress = function(w) {
        this.hasAnyBroken = this.hasAnyBroken || !w.isLoaded;
        var b = this;
        setTimeout(function() {
            b.emit("progress", b, w),
            b.jqDeferred && b.jqDeferred.notify && b.jqDeferred.notify(b, w)
        })
    }
    ,
    t.prototype.complete = function() {
        var w = this.hasAnyBroken ? "fail" : "done";
        this.isComplete = !0;
        var b = this;
        setTimeout(function() {
            if (b.emit(w, b),
            b.emit("always", b),
            b.jqDeferred) {
                var A = b.hasAnyBroken ? "reject" : "resolve";
                b.jqDeferred[A](b)
            }
        })
    }
    ,
    o && (o.fn.imagesLoaded = function(w, b) {
        var A = new t(this,w,b);
        return A.jqDeferred.promise(o(this))
    }
    ),
    e.prototype = new v,
    e.prototype.check = function() {
        var w = C[this.img.src] || new r(this.img.src);
        if (w.isConfirmed)
            return this.confirm(w.isLoaded, "cached was confirmed"),
            void 0;
        if (this.img.complete && this.img.naturalWidth !== void 0)
            return this.confirm(this.img.naturalWidth !== 0, "naturalWidth"),
            void 0;
        var b = this;
        w.on("confirm", function(A, _) {
            return b.confirm(A.isLoaded, _),
            !0
        }),
        w.check()
    }
    ,
    e.prototype.confirm = function(w, b) {
        this.isLoaded = w,
        this.emit("confirm", this, b)
    }
    ;
    var C = {};
    return r.prototype = new v,
    r.prototype.check = function() {
        if (!this.isChecked) {
            var w = new Image;
            g.bind(w, "load", this),
            g.bind(w, "error", this),
            w.src = this.src,
            this.isChecked = !0
        }
    }
    ,
    r.prototype.handleEvent = function(w) {
        var b = "on" + w.type;
        this[b] && this[b](w)
    }
    ,
    r.prototype.onload = function(w) {
        this.confirm(!0, "onload"),
        this.unbindProxyEvents(w)
    }
    ,
    r.prototype.onerror = function(w) {
        this.confirm(!1, "onerror"),
        this.unbindProxyEvents(w)
    }
    ,
    r.prototype.confirm = function(w, b) {
        this.isConfirmed = !0,
        this.isLoaded = w,
        this.emit("confirm", this, b)
    }
    ,
    r.prototype.unbindProxyEvents = function(w) {
        g.unbind(w.target, "load", this),
        g.unbind(w.target, "error", this)
    }
    ,
    t
}),
function(s) {
    typeof define == "function" && define.amd ? define(["jquery"], s) : s(jQuery)
}(function(s) {
    function v(p, u) {
        var t = g(p)
          , e = u ? g(u) : t
          , r = []
          , o = 0
          , h = 0
          , k = t.length
          , C = u ? e.length : t.length;
        for (u || (u = p); o < k; o++)
            for (h = 0; h < C; h++)
                p[o] !== u[h] && a(t[o], e[h]) && r.push(k > C ? p[o] : u[h]);
        return s.unique(r)
    }
    function g(p) {
        for (var u, t, e = [], r = 0; t = p[r++]; )
            u = s(t).offset(),
            e.push([u.top, u.left, t.offsetWidth, t.offsetHeight]);
        return e
    }
    function a(p, u) {
        var t = p[1]
          , e = p[0]
          , r = p[2]
          , o = p[3]
          , h = u[1]
          , k = u[0]
          , C = u[2]
          , w = u[3];
        return !(k + w <= e || e + o <= k || h + C <= t || t + r <= h)
    }
    s.fn.overlaps = function(p) {
        return this.pushStack(v(this, p && s(p)))
    }
}),
function(s) {
    s.fn.mobileTable = function(v) {
        var g = {
            breakpoint: 720
        };
        return v && s.extend(g, v),
        this.each(function() {
            var a = s(this);
            if (window.innerWidth < g.breakpoint) {
                if (a.hasClass("titles-ready"))
                    return void a.addClass("mobile-layout");
                a.addClass("mobile-layout titles-ready"),
                a.find("thead th").each(function(p) {
                    var u = s(this).text();
                    a.find("tr td:nth-child(" + (p + 1) + ")").prepend('<span class="column-title">' + u + "</span>")
                })
            } else
                a.removeClass("mobile-layout")
        })
    }
}(jQuery),
typeof Object.create != "function" && (Object.create = function(s) {
    function v() {}
    return v.prototype = s,
    new v
}
),
function(s, v, g) {
    var a = function(t) {
        var e = g.createElement("script")
          , r = g.getElementsByTagName("head")[0];
        e.src = v.location.origin == "file://" ? "http://www.youtube.com/iframe_api" : "//www.youtube.com/iframe_api",
        r.appendChild(e),
        r = null,
        e = null,
        p(t)
    }
      , p = function(t) {
        typeof YT == "undefined" && typeof v.loadingPlayer == "undefined" ? (v.loadingPlayer = !0,
        v.dfd = s.Deferred(),
        v.onYouTubeIframeAPIReady = function() {
            v.onYouTubeIframeAPIReady = null,
            v.dfd.resolve("done"),
            t()
        }
        ) : typeof YT == "object" ? t() : v.dfd.done(function() {
            t()
        })
    }
      , u = {
        player: null,
        defaults: {
            ratio: 1.7777777777777777,
            videoId: "LSmgKRx5pBo",
            mute: !0,
            repeat: !0,
            width: s(v).width(),
            playButtonClass: "YTPlayer-play",
            pauseButtonClass: "YTPlayer-pause",
            muteButtonClass: "YTPlayer-mute",
            volumeUpClass: "YTPlayer-volume-up",
            volumeDownClass: "YTPlayer-volume-down",
            start: 0,
            fitToBackground: !0,
            playerVars: {
                iv_load_policy: 3,
                modestbranding: 1,
                autoplay: 1,
                controls: 0,
                showinfo: 0,
                wmode: "opaque",
                branding: 0,
                autohide: 0
            },
            events: null
        },
        init: function(t, e) {
            var r = this;
            return r.userOptions = e,
            r.$body = s("body"),
            r.$node = s(t),
            r.$window = s(v),
            r.defaults.events = {
                onReady: function(o) {
                    r.onPlayerReady(o),
                    typeof r.options.callback == "function" && r.options.callback.call(this)
                },
                onStateChange: function(o) {
                    o.data === 1 ? (r.$node.find("img").fadeOut(400),
                    r.$node.addClass("loaded")) : o.data === 0 && r.options.repeat && r.player.seekTo(r.options.start)
                }
            },
            r.options = s.extend(!0, {}, r.defaults, r.userOptions),
            r.options.height = Math.ceil(r.options.width / r.options.ratio),
            r.ID = new Date().getTime(),
            r.holderID = "YTPlayer-ID-" + r.ID,
            r.options.fitToBackground ? r.createBackgroundVideo() : r.createContainerVideo(),
            a(r.onYouTubeIframeAPIReady.bind(r)),
            r
        },
        createContainerVideo: function() {
            var t = this
              , e = s('<div id="ytplayer-container' + t.ID + '" >                                    <div id="' + t.holderID + '" class="ytplayer-player-inline"></div>                                     </div>                                     <div id="ytplayer-shield" class="ytplayer-shield"></div>');
            t.$node.append(e),
            t.$YTPlayerString = e,
            e = null
        },
        createBackgroundVideo: function() {
            var t = this
              , e = s('<div id="ytplayer-container' + t.ID + '" class="ytplayer-container background">                                    <div id="' + t.holderID + '" class="ytplayer-player"></div>                                    </div>                                    <div id="ytplayer-shield" class="ytplayer-shield"></div>');
            t.$node.append(e),
            t.$YTPlayerString = e,
            e = null
        },
        onYouTubeIframeAPIReady: function() {
            var t = this;
            t.player = new v.YT.Player(t.holderID,t.options)
        },
        onPlayerReady: function(t) {
            this.options.mute && t.target.mute(),
            t.target.playVideo()
        },
        getPlayer: function() {
            return this.player
        },
        destroy: function() {
            var t = this;
            t.$node.removeData("yt-init").removeData("ytPlayer").removeClass("loaded"),
            t.$YTPlayerString.remove(),
            t.$body = null,
            t.$node = null,
            t.$YTPlayerString = null,
            t.player.destroy(),
            t.player = null
        }
    };
    s.fn.YTPlayer = function(t) {
        return this.each(function() {
            var e = this;
            s(e).data("yt-init", !0);
            var r = Object.create(u);
            r.init(e, t),
            s.data(e, "ytPlayer", r)
        })
    }
}(jQuery, window, document),
function(s) {
    function v() {}
    function g(p) {
        function u(r) {
            r.prototype.option || (r.prototype.option = function(o) {
                p.isPlainObject(o) && (this.options = p.extend(!0, this.options, o))
            }
            )
        }
        function t(r, o) {
            p.fn[r] = function(h) {
                if (typeof h == "string") {
                    for (var k = a.call(arguments, 1), C = 0, w = this.length; w > C; C++) {
                        var b = this[C]
                          , A = p.data(b, r);
                        if (!A)
                            e("cannot call methods on " + r + " prior to initialization; attempted to call '" + h + "'");
                        else if (p.isFunction(A[h]) && h.charAt(0) !== "_") {
                            var _ = A[h].apply(A, k);
                            if (_ !== void 0)
                                return _
                        } else
                            e("no such method '" + h + "' for " + r + " instance")
                    }
                    return this
                }
                return this.each(function() {
                    var x = p.data(this, r);
                    x ? (x.option(h),
                    x._init()) : (x = new o(this,h),
                    p.data(this, r, x))
                })
            }
        }
        if (p) {
            var e = typeof console == "undefined" ? v : function(r) {
                console.error(r)
            }
            ;
            return p.bridget = function(r, o) {
                u(o),
                t(r, o)
            }
            ,
            p.bridget
        }
    }
    var a = Array.prototype.slice;
    typeof define == "function" && define.amd ? define("jquery-bridget/jquery.bridget", ["jquery"], g) : g(typeof exports == "object" ? require("jquery") : s.jQuery)
}(window),
function(s) {
    function v(e) {
        return new RegExp("(^|\\s+)" + e + "(\\s+|$)")
    }
    function g(e, r) {
        var o = a(e, r) ? u : p;
        o(e, r)
    }
    var a, p, u;
    "classList"in document.documentElement ? (a = function(e, r) {
        return e.classList.contains(r)
    }
    ,
    p = function(e, r) {
        e.classList.add(r)
    }
    ,
    u = function(e, r) {
        e.classList.remove(r)
    }
    ) : (a = function(e, r) {
        return v(r).test(e.className)
    }
    ,
    p = function(e, r) {
        a(e, r) || (e.className = e.className + " " + r)
    }
    ,
    u = function(e, r) {
        e.className = e.className.replace(v(r), " ")
    }
    );
    var t = {
        hasClass: a,
        addClass: p,
        removeClass: u,
        toggleClass: g,
        has: a,
        add: p,
        remove: u,
        toggle: g
    };
    typeof define == "function" && define.amd ? define("classie/classie", t) : typeof exports == "object" ? module.exports = t : s.classie = t
}(window),
function() {
    "use strict";
    function s() {}
    function v(t, e) {
        for (var r = t.length; r--; )
            if (t[r].listener === e)
                return r;
        return -1
    }
    function g(t) {
        return function() {
            return this[t].apply(this, arguments)
        }
    }
    var a = s.prototype
      , p = this
      , u = p.EventEmitter;
    a.getListeners = function(t) {
        var e, r, o = this._getEvents();
        if (t instanceof RegExp)
            for (r in e = {},
            o)
                o.hasOwnProperty(r) && t.test(r) && (e[r] = o[r]);
        else
            e = o[t] || (o[t] = []);
        return e
    }
    ,
    a.flattenListeners = function(t) {
        var e, r = [];
        for (e = 0; e < t.length; e += 1)
            r.push(t[e].listener);
        return r
    }
    ,
    a.getListenersAsObject = function(t) {
        var e, r = this.getListeners(t);
        return r instanceof Array && (e = {},
        e[t] = r),
        e || r
    }
    ,
    a.addListener = function(t, e) {
        var r, o = this.getListenersAsObject(t);
        for (r in o)
            o.hasOwnProperty(r) && v(o[r], e) === -1 && o[r].push(typeof e == "object" ? e : {
                listener: e,
                once: !1
            });
        return this
    }
    ,
    a.on = g("addListener"),
    a.addOnceListener = function(t, e) {
        return this.addListener(t, {
            listener: e,
            once: !0
        })
    }
    ,
    a.once = g("addOnceListener"),
    a.defineEvent = function(t) {
        return this.getListeners(t),
        this
    }
    ,
    a.defineEvents = function(t) {
        for (var e = 0; e < t.length; e += 1)
            this.defineEvent(t[e]);
        return this
    }
    ,
    a.removeListener = function(t, e) {
        var r, o, h = this.getListenersAsObject(t);
        for (o in h)
            h.hasOwnProperty(o) && (r = v(h[o], e),
            r !== -1 && h[o].splice(r, 1));
        return this
    }
    ,
    a.off = g("removeListener"),
    a.addListeners = function(t, e) {
        return this.manipulateListeners(!1, t, e)
    }
    ,
    a.removeListeners = function(t, e) {
        return this.manipulateListeners(!0, t, e)
    }
    ,
    a.manipulateListeners = function(t, e, r) {
        var o, h, k = t ? this.removeListener : this.addListener, C = t ? this.removeListeners : this.addListeners;
        if (typeof e != "object" || e instanceof RegExp)
            for (o = r.length; o--; )
                k.call(this, e, r[o]);
        else
            for (o in e)
                e.hasOwnProperty(o) && (h = e[o]) && (typeof h == "function" ? k.call(this, o, h) : C.call(this, o, h));
        return this
    }
    ,
    a.removeEvent = function(t) {
        var e, r = this._getEvents();
        if (typeof t == "string")
            delete r[t];
        else if (t instanceof RegExp)
            for (e in r)
                r.hasOwnProperty(e) && t.test(e) && delete r[e];
        else
            delete this._events;
        return this
    }
    ,
    a.removeAllListeners = g("removeEvent"),
    a.emitEvent = function(t, e) {
        var r, o, h, k, C = this.getListenersAsObject(t);
        for (h in C)
            if (C.hasOwnProperty(h))
                for (o = C[h].length; o--; )
                    r = C[h][o],
                    r.once === !0 && this.removeListener(t, r.listener),
                    k = r.listener.apply(this, e || []),
                    k === this._getOnceReturnValue() && this.removeListener(t, r.listener);
        return this
    }
    ,
    a.trigger = g("emitEvent"),
    a.emit = function(t) {
        var e = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(t, e)
    }
    ,
    a.setOnceReturnValue = function(t) {
        return this._onceReturnValue = t,
        this
    }
    ,
    a._getOnceReturnValue = function() {
        return !this.hasOwnProperty("_onceReturnValue") || this._onceReturnValue
    }
    ,
    a._getEvents = function() {
        return this._events || (this._events = {})
    }
    ,
    s.noConflict = function() {
        return p.EventEmitter = u,
        s
    }
    ,
    typeof define == "function" && define.amd ? define("eventEmitter/EventEmitter", [], function() {
        return s
    }) : typeof module == "object" && module.exports ? module.exports = s : p.EventEmitter = s
}
.call(this),
function(s) {
    function v(t) {
        var e = s.event;
        return e.target = e.target || e.srcElement || t,
        e
    }
    var g = document.documentElement
      , a = function() {};
    g.addEventListener ? a = function(t, e, r) {
        t.addEventListener(e, r, !1)
    }
    : g.attachEvent && (a = function(t, e, r) {
        t[e + r] = r.handleEvent ? function() {
            var o = v(t);
            r.handleEvent.call(r, o)
        }
        : function() {
            var o = v(t);
            r.call(t, o)
        }
        ,
        t.attachEvent("on" + e, t[e + r])
    }
    );
    var p = function() {};
    g.removeEventListener ? p = function(t, e, r) {
        t.removeEventListener(e, r, !1)
    }
    : g.detachEvent && (p = function(t, e, r) {
        t.detachEvent("on" + e, t[e + r]);
        try {
            delete t[e + r]
        } catch (o) {
            t[e + r] = void 0
        }
    }
    );
    var u = {
        bind: a,
        unbind: p
    };
    typeof define == "function" && define.amd ? define("eventie/eventie", u) : typeof exports == "object" ? module.exports = u : s.eventie = u
}(window),
function(s) {
    function v(p) {
        if (p) {
            if (typeof a[p] == "string")
                return p;
            p = p.charAt(0).toUpperCase() + p.slice(1);
            for (var u, t = 0, e = g.length; e > t; t++)
                if (u = g[t] + p,
                typeof a[u] == "string")
                    return u
        }
    }
    var g = "Webkit Moz ms Ms O".split(" ")
      , a = document.documentElement.style;
    typeof define == "function" && define.amd ? define("get-style-property/get-style-property", [], function() {
        return v
    }) : typeof exports == "object" ? module.exports = v : s.getStyleProperty = v
}(window),
function(s) {
    function v(t) {
        var e = parseFloat(t)
          , r = t.indexOf("%") === -1 && !isNaN(e);
        return r && e
    }
    function g() {
        for (var t, e = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        }, r = 0, o = u.length; o > r; r++)
            t = u[r],
            e[t] = 0;
        return e
    }
    function a(t) {
        function e() {
            if (!C) {
                C = !0;
                var w = s.getComputedStyle;
                if (o = function() {
                    var x = w ? function(T) {
                        return w(T, null)
                    }
                    : function(T) {
                        return T.currentStyle
                    }
                    ;
                    return function(T) {
                        var I = x(T);
                        return I || p("Style returned " + I + ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"),
                        I
                    }
                }(),
                h = t("boxSizing")) {
                    var b = document.createElement("div");
                    b.style.width = "200px",
                    b.style.padding = "1px 2px 3px 4px",
                    b.style.borderStyle = "solid",
                    b.style.borderWidth = "1px 2px 3px 4px",
                    b.style[h] = "border-box";
                    var A = document.body || document.documentElement;
                    A.appendChild(b);
                    var _ = o(b);
                    k = v(_.width) === 200,
                    A.removeChild(b)
                }
            }
        }
        function r(w, b) {
            if (s.getComputedStyle || b.indexOf("%") === -1)
                return b;
            var A = w.style
              , _ = A.left
              , x = w.runtimeStyle
              , T = x && x.left;
            return T && (x.left = w.currentStyle.left),
            A.left = b,
            b = A.pixelLeft,
            A.left = _,
            T && (x.left = T),
            b
        }
        var o, h, k, C = !1;
        return function(w) {
            if (e(),
            typeof w == "string" && (w = document.querySelector(w)),
            w && typeof w == "object" && w.nodeType) {
                var b = o(w);
                if (b.display === "none")
                    return g();
                for (var A = {
                    width: w.offsetWidth,
                    height: w.offsetHeight
                }, _ = A.isBorderBox = h && b[h] && b[h] === "border-box", x = 0, T = u.length; T > x; x++) {
                    var I = u[x]
                      , q = b[I];
                    q = r(w, q);
                    var $ = parseFloat(q);
                    A[I] = isNaN($) ? 0 : $
                }
                var Y = A.paddingLeft + A.paddingRight
                  , l = A.paddingTop + A.paddingBottom
                  , F = A.marginLeft + A.marginRight
                  , J = A.marginTop + A.marginBottom
                  , G = A.borderLeftWidth + A.borderRightWidth
                  , Q = A.borderTopWidth + A.borderBottomWidth
                  , i = _ && k
                  , c = v(b.width);
                c !== !1 && (A.width = c + (i ? 0 : Y + G));
                var m = v(b.height);
                return m !== !1 && (A.height = m + (i ? 0 : l + Q)),
                A.innerWidth = A.width - (Y + G),
                A.innerHeight = A.height - (l + Q),
                A.outerWidth = A.width + F,
                A.outerHeight = A.height + J,
                A
            }
        }
    }
    var p = typeof console == "undefined" ? function() {}
    : function(t) {
        console.error(t)
    }
      , u = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"];
    typeof define == "function" && define.amd ? define("get-size/get-size", ["get-style-property/get-style-property"], a) : typeof exports == "object" ? module.exports = a(require("desandro-get-style-property")) : s.getSize = a(s.getStyleProperty)
}(window),
function(s) {
    function v(e) {
        typeof e == "function" && (v.isReady ? e() : t.push(e))
    }
    function g(e) {
        var r = e.type === "readystatechange" && u.readyState !== "complete";
        v.isReady || r || a()
    }
    function a() {
        v.isReady = !0;
        for (var e, r = 0, o = t.length; o > r; r++)
            e = t[r],
            e()
    }
    function p(e) {
        return u.readyState === "complete" ? a() : (e.bind(u, "DOMContentLoaded", g),
        e.bind(u, "readystatechange", g),
        e.bind(s, "load", g)),
        v
    }
    var u = s.document
      , t = [];
    v.isReady = !1,
    typeof define == "function" && define.amd ? define("doc-ready/doc-ready", ["eventie/eventie"], p) : typeof exports == "object" ? module.exports = p(require("eventie")) : s.docReady = p(s.eventie)
}(window),
function(s) {
    "use strict";
    function v(r, o) {
        return r[u](o)
    }
    function g(r) {
        if (!r.parentNode) {
            var o = document.createDocumentFragment();
            o.appendChild(r)
        }
    }
    function a(r, o) {
        return g(r),
        v(r, o)
    }
    var p, u = function() {
        if (s.matches)
            return "matches";
        if (s.matchesSelector)
            return "matchesSelector";
        for (var r = ["webkit", "moz", "ms", "o"], o = 0, h = r.length; h > o; o++) {
            var k = r[o]
              , C = k + "MatchesSelector";
            if (s[C])
                return C
        }
    }();
    if (u) {
        var t = document.createElement("div")
          , e = v(t, "div");
        p = e ? v : a
    } else
        p = function(r, o) {
            g(r);
            for (var h = r.parentNode.querySelectorAll(o), k = 0, C = h.length; C > k; k++)
                if (h[k] === r)
                    return !0;
            return !1
        }
        ;
    typeof define == "function" && define.amd ? define("matches-selector/matches-selector", [], function() {
        return p
    }) : typeof exports == "object" ? module.exports = p : window.matchesSelector = p
}(Element.prototype),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define("fizzy-ui-utils/utils", ["doc-ready/doc-ready", "matches-selector/matches-selector"], function(g, a) {
        return v(s, g, a)
    }) : typeof exports == "object" ? module.exports = v(s, require("doc-ready"), require("desandro-matches-selector")) : s.fizzyUIUtils = v(s, s.docReady, s.matchesSelector)
}(window, function(s, v, g) {
    var a = {
        extend: function(t, e) {
            for (var r in e)
                t[r] = e[r];
            return t
        },
        modulo: function(t, e) {
            return (t % e + e) % e
        }
    }
      , p = Object.prototype.toString;
    a.isArray = function(t) {
        return p.call(t) == "[object Array]"
    }
    ,
    a.makeArray = function(t) {
        var e = [];
        if (a.isArray(t))
            e = t;
        else if (t && typeof t.length == "number")
            for (var r = 0, o = t.length; o > r; r++)
                e.push(t[r]);
        else
            e.push(t);
        return e
    }
    ,
    a.indexOf = Array.prototype.indexOf ? function(t, e) {
        return t.indexOf(e)
    }
    : function(t, e) {
        for (var r = 0, o = t.length; o > r; r++)
            if (t[r] === e)
                return r;
        return -1
    }
    ,
    a.removeFrom = function(t, e) {
        var r = a.indexOf(t, e);
        r != -1 && t.splice(r, 1)
    }
    ,
    a.isElement = typeof HTMLElement == "function" || typeof HTMLElement == "object" ? function(t) {
        return t instanceof HTMLElement
    }
    : function(t) {
        return t && typeof t == "object" && t.nodeType == 1 && typeof t.nodeName == "string"
    }
    ,
    a.setText = function() {
        var t;
        return function(e, r) {
            t = t || (document.documentElement.textContent === void 0 ? "innerText" : "textContent"),
            e[t] = r
        }
    }(),
    a.getParent = function(t, e) {
        for (; t != document.body; )
            if (t = t.parentNode,
            g(t, e))
                return t
    }
    ,
    a.getQueryElement = function(t) {
        return typeof t == "string" ? document.querySelector(t) : t
    }
    ,
    a.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }
    ,
    a.filterFindElements = function(t, e) {
        t = a.makeArray(t);
        for (var r, o = [], h = 0, k = t.length; k > h; h++)
            if (r = t[h],
            a.isElement(r))
                if (e) {
                    g(r, e) && o.push(r);
                    for (var C = r.querySelectorAll(e), w = 0, b = C.length; b > w; w++)
                        o.push(C[w])
                } else
                    o.push(r);
        return o
    }
    ,
    a.debounceMethod = function(t, e, r) {
        var o = t.prototype[e]
          , h = e + "Timeout";
        t.prototype[e] = function() {
            var k = this[h];
            k && clearTimeout(k);
            var C = arguments
              , w = this;
            this[h] = setTimeout(function() {
                o.apply(w, C),
                delete w[h]
            }, r || 100)
        }
    }
    ,
    a.toDashed = function(t) {
        return t.replace(/(.)([A-Z])/g, function(e, r, o) {
            return r + "-" + o
        }).toLowerCase()
    }
    ;
    var u = s.console;
    return a.htmlInit = function(t, e) {
        v(function() {
            for (var r = a.toDashed(e), o = document.querySelectorAll(".js-" + r), h = "data-" + r + "-options", k = 0, C = o.length; C > k; k++) {
                var w, b = o[k], A = b.getAttribute(h);
                try {
                    w = A && JSON.parse(A)
                } catch (T) {
                    u && u.error("Error parsing " + h + " on " + b.nodeName.toLowerCase() + (b.id ? "#" + b.id : "") + ": " + T);
                    continue
                }
                var _ = new t(b,w)
                  , x = s.jQuery;
                x && x.data(b, e, _)
            }
        })
    }
    ,
    a
}),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define("flickity/js/cell", ["get-size/get-size"], function(g) {
        return v(s, g)
    }) : typeof exports == "object" ? module.exports = v(s, require("get-size")) : (s.Flickity = s.Flickity || {},
    s.Flickity.Cell = v(s, s.getSize))
}(window, function(s, v) {
    function g(a, p) {
        this.element = a,
        this.parent = p,
        this.create()
    }
    return g.prototype.create = function() {
        this.element.style.position = "absolute",
        "attachEvent"in s && this.element.setAttribute("unselectable", "on"),
        this.x = 0,
        this.shift = 0
    }
    ,
    g.prototype.destroy = function() {
        this.element.style.position = "";
        var a = this.parent.originSide;
        this.element.style[a] = ""
    }
    ,
    g.prototype.getSize = function() {
        this.size = v(this.element)
    }
    ,
    g.prototype.setPosition = function(a) {
        this.x = a,
        this.setDefaultTarget(),
        this.renderPosition(a)
    }
    ,
    g.prototype.setDefaultTarget = function() {
        var a = this.parent.originSide == "left" ? "marginLeft" : "marginRight";
        this.target = this.x + this.size[a] + this.size.width * this.parent.cellAlign
    }
    ,
    g.prototype.renderPosition = function(a) {
        var p = this.parent.originSide;
        this.element.style[p] = this.parent.getPositionValue(a)
    }
    ,
    g.prototype.wrapShift = function(a) {
        this.shift = a,
        this.renderPosition(this.x + this.parent.slideableWidth * a)
    }
    ,
    g.prototype.remove = function() {
        this.element.parentNode.removeChild(this.element)
    }
    ,
    g
}),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define("flickity/js/animate", ["get-style-property/get-style-property", "fizzy-ui-utils/utils"], function(g, a) {
        return v(s, g, a)
    }) : typeof exports == "object" ? module.exports = v(s, require("desandro-get-style-property"), require("fizzy-ui-utils")) : (s.Flickity = s.Flickity || {},
    s.Flickity.animatePrototype = v(s, s.getStyleProperty, s.fizzyUIUtils))
}(window, function(s, v, g) {
    for (var a, p = 0, u = "webkit moz ms o".split(" "), t = s.requestAnimationFrame, e = s.cancelAnimationFrame, r = 0; r < u.length && (!t || !e); r++)
        a = u[r],
        t = t || s[a + "RequestAnimationFrame"],
        e = e || s[a + "CancelAnimationFrame"] || s[a + "CancelRequestAnimationFrame"];
    t && e || (t = function(C) {
        var w = new Date().getTime()
          , b = Math.max(0, 16 - (w - p))
          , A = s.setTimeout(function() {
            C(w + b)
        }, b);
        return p = w + b,
        A
    }
    ,
    e = function(C) {
        s.clearTimeout(C)
    }
    );
    var o = {
        startAnimation: function() {
            this.isAnimating || (this.isAnimating = !0,
            this.restingFrames = 0,
            this.animate())
        },
        animate: function() {
            this.applyDragForce(),
            this.applySelectedAttraction();
            var C = this.x;
            if (this.integratePhysics(),
            this.positionSlider(),
            this.settle(C),
            this.isAnimating) {
                var w = this;
                t(function() {
                    w.animate()
                })
            }
        }
    }
      , h = v("transform")
      , k = !!v("perspective");
    return o.positionSlider = function() {
        var C = this.x;
        this.options.wrapAround && 1 < this.cells.length && (C = g.modulo(C, this.slideableWidth),
        C -= this.slideableWidth,
        this.shiftWrapCells(C)),
        C += this.cursorPosition,
        C = this.options.rightToLeft && h ? -C : C;
        var w = this.getPositionValue(C);
        h ? this.slider.style[h] = k && this.isAnimating ? "translate3d(" + w + ",0,0)" : "translateX(" + w + ")" : this.slider.style[this.originSide] = w
    }
    ,
    o.positionSliderAtSelected = function() {
        if (this.cells.length) {
            var C = this.cells[this.selectedIndex];
            this.x = -C.target,
            this.positionSlider()
        }
    }
    ,
    o.getPositionValue = function(C) {
        return this.options.percentPosition ? .01 * Math.round(1e4 * (C / this.size.innerWidth)) + "%" : Math.round(C) + "px"
    }
    ,
    o.settle = function(C) {
        this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * C) || this.restingFrames++,
        2 < this.restingFrames && (this.isAnimating = !1,
        delete this.isFreeScrolling,
        k && this.positionSlider(),
        this.dispatchEvent("settle"))
    }
    ,
    o.shiftWrapCells = function(C) {
        var w = this.cursorPosition + C;
        this._shiftCells(this.beforeShiftCells, w, -1);
        var b = this.size.innerWidth - (C + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, b, 1)
    }
    ,
    o._shiftCells = function(C, w, b) {
        for (var A = 0, _ = C.length; _ > A; A++) {
            var x = C[A]
              , T = 0 < w ? b : 0;
            x.wrapShift(T),
            w -= x.size.outerWidth
        }
    }
    ,
    o._unshiftCells = function(C) {
        if (C && C.length)
            for (var w = 0, b = C.length; b > w; w++)
                C[w].wrapShift(0)
    }
    ,
    o.integratePhysics = function() {
        this.velocity += this.accel,
        this.x += this.velocity,
        this.velocity *= this.getFrictionFactor(),
        this.accel = 0
    }
    ,
    o.applyForce = function(C) {
        this.accel += C
    }
    ,
    o.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
    }
    ,
    o.getRestingPosition = function() {
        return this.x + this.velocity / (1 - this.getFrictionFactor())
    }
    ,
    o.applyDragForce = function() {
        if (this.isPointerDown) {
            var C = this.dragX - this.x
              , w = C - this.velocity;
            this.applyForce(w)
        }
    }
    ,
    o.applySelectedAttraction = function() {
        var C = this.cells.length;
        if (!this.isPointerDown && !this.isFreeScrolling && C) {
            var w = this.cells[this.selectedIndex]
              , b = this.options.wrapAround && 1 < C ? this.slideableWidth * Math.floor(this.selectedIndex / C) : 0
              , A = -1 * (w.target + b) - this.x
              , _ = A * this.options.selectedAttraction;
            this.applyForce(_)
        }
    }
    ,
    o
}),
function(s, v) {
    "use strict";
    if (typeof define == "function" && define.amd)
        define("flickity/js/flickity", ["classie/classie", "eventEmitter/EventEmitter", "eventie/eventie", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./animate"], function(a, p, u, t, e, r, o) {
            return v(s, a, p, u, t, e, r, o)
        });
    else if (typeof exports == "object")
        module.exports = v(s, require("desandro-classie"), require("wolfy87-eventemitter"), require("eventie"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./animate"));
    else {
        var g = s.Flickity;
        s.Flickity = v(s, s.classie, s.EventEmitter, s.eventie, s.getSize, s.fizzyUIUtils, g.Cell, g.animatePrototype)
    }
}(window, function(s, v, g, a, p, u, t, e) {
    function r(x, T) {
        for (x = u.makeArray(x); x.length; )
            T.appendChild(x.shift())
    }
    function o(x, T) {
        var I = u.getQueryElement(x);
        return I ? (this.element = I,
        h && (this.$element = h(this.element)),
        this.options = u.extend({}, this.constructor.defaults),
        this.option(T),
        void this._create()) : void (C && C.error("Bad element for Flickity: " + (I || x)))
    }
    var h = s.jQuery
      , k = s.getComputedStyle
      , C = s.console
      , w = 0
      , b = {};
    o.defaults = {
        accessibility: !0,
        cellAlign: "center",
        freeScrollFriction: .075,
        friction: .28,
        percentPosition: !0,
        resize: !0,
        selectedAttraction: .025,
        setGallerySize: !0
    },
    o.createMethods = [],
    u.extend(o.prototype, g.prototype),
    o.prototype._create = function() {
        var x = this.guid = ++w;
        this.element.flickityGUID = x,
        b[x] = this,
        this.selectedIndex = 0,
        this.restingFrames = 0,
        this.x = 0,
        this.velocity = 0,
        this.accel = 0,
        this.originSide = this.options.rightToLeft ? "right" : "left",
        this.viewport = document.createElement("div"),
        this.viewport.className = "flickity-viewport",
        o.setUnselectable(this.viewport),
        this._createSlider(),
        (this.options.resize || this.options.watchCSS) && (a.bind(s, "resize", this),
        this.isResizeBound = !0);
        for (var T, I = 0, q = o.createMethods.length; q > I; I++)
            T = o.createMethods[I],
            this[T]();
        this.options.watchCSS ? this.watchCSS() : this.activate()
    }
    ,
    o.prototype.option = function(x) {
        u.extend(this.options, x)
    }
    ,
    o.prototype.activate = function() {
        if (!this.isActive) {
            this.isActive = !0,
            v.add(this.element, "flickity-enabled"),
            this.options.rightToLeft && v.add(this.element, "flickity-rtl"),
            this.getSize();
            var x = this._filterFindCellElements(this.element.children);
            r(x, this.slider),
            this.viewport.appendChild(this.slider),
            this.element.appendChild(this.viewport),
            this.reloadCells(),
            this.options.accessibility && (this.element.tabIndex = 0,
            a.bind(this.element, "keydown", this)),
            this.emit("activate");
            var T, I = this.options.initialIndex;
            T = this.isInitActivated ? this.selectedIndex : I !== void 0 && this.cells[I] ? I : 0,
            this.select(T, !1, !0),
            this.isInitActivated = !0
        }
    }
    ,
    o.prototype._createSlider = function() {
        var x = document.createElement("div");
        x.className = "flickity-slider",
        x.style[this.originSide] = 0,
        this.slider = x
    }
    ,
    o.prototype._filterFindCellElements = function(x) {
        return u.filterFindElements(x, this.options.cellSelector)
    }
    ,
    o.prototype.reloadCells = function() {
        this.cells = this._makeCells(this.slider.children),
        this.positionCells(),
        this._getWrapShiftCells(),
        this.setGallerySize()
    }
    ,
    o.prototype._makeCells = function(x) {
        for (var T = this._filterFindCellElements(x), I = [], q = 0, $ = T.length; $ > q; q++) {
            var Y = T[q]
              , l = new t(Y,this);
            I.push(l)
        }
        return I
    }
    ,
    o.prototype.getLastCell = function() {
        return this.cells[this.cells.length - 1]
    }
    ,
    o.prototype.positionCells = function() {
        this._sizeCells(this.cells),
        this._positionCells(0)
    }
    ,
    o.prototype._positionCells = function(x) {
        x = x || 0,
        this.maxCellHeight = x && this.maxCellHeight || 0;
        var T = 0;
        if (0 < x) {
            var I = this.cells[x - 1];
            T = I.x + I.size.outerWidth
        }
        for (var q, $ = this.cells.length, Y = x; $ > Y; Y++)
            q = this.cells[Y],
            q.setPosition(T),
            T += q.size.outerWidth,
            this.maxCellHeight = Math.max(q.size.outerHeight, this.maxCellHeight);
        this.slideableWidth = T,
        this._containCells()
    }
    ,
    o.prototype._sizeCells = function(x) {
        for (var T, I = 0, q = x.length; q > I; I++)
            T = x[I],
            T.getSize()
    }
    ,
    o.prototype._init = o.prototype.reposition = function() {
        this.positionCells(),
        this.positionSliderAtSelected()
    }
    ,
    o.prototype.getSize = function() {
        this.size = p(this.element),
        this.setCellAlign(),
        this.cursorPosition = this.size.innerWidth * this.cellAlign
    }
    ;
    var A = {
        center: {
            left: .5,
            right: .5
        },
        left: {
            left: 0,
            right: 1
        },
        right: {
            right: 0,
            left: 1
        }
    };
    o.prototype.setCellAlign = function() {
        var x = A[this.options.cellAlign];
        this.cellAlign = x ? x[this.originSide] : this.options.cellAlign
    }
    ,
    o.prototype.setGallerySize = function() {
        this.options.setGallerySize && (this.viewport.style.height = this.maxCellHeight + "px")
    }
    ,
    o.prototype._getWrapShiftCells = function() {
        if (this.options.wrapAround) {
            this._unshiftCells(this.beforeShiftCells),
            this._unshiftCells(this.afterShiftCells);
            var x = this.cursorPosition
              , T = this.cells.length - 1;
            this.beforeShiftCells = this._getGapCells(x, T, -1),
            x = this.size.innerWidth - this.cursorPosition,
            this.afterShiftCells = this._getGapCells(x, 0, 1)
        }
    }
    ,
    o.prototype._getGapCells = function(x, T, I) {
        for (var q, $ = []; 0 < x && (q = this.cells[T],
        !!q); )
            $.push(q),
            T += I,
            x -= q.size.outerWidth;
        return $
    }
    ,
    o.prototype._containCells = function() {
        if (this.options.contain && !this.options.wrapAround && this.cells.length)
            for (var x, T = this.options.rightToLeft ? "marginRight" : "marginLeft", I = this.options.rightToLeft ? "marginLeft" : "marginRight", q = this.cells[0].size[T], $ = this.getLastCell(), Y = this.slideableWidth - $.size[I], l = Y - this.size.innerWidth * (1 - this.cellAlign), F = Y < this.size.innerWidth, J = 0, G = this.cells.length; G > J; J++)
                x = this.cells[J],
                x.setDefaultTarget(),
                F ? x.target = Y * this.cellAlign : (x.target = Math.max(x.target, this.cursorPosition + q),
                x.target = Math.min(x.target, l))
    }
    ,
    o.prototype.dispatchEvent = function(x, T, I) {
        var q = [T].concat(I);
        if (this.emitEvent(x, q),
        h && this.$element)
            if (T) {
                var $ = h.Event(T);
                $.type = x,
                this.$element.trigger($, I)
            } else
                this.$element.trigger(x, I)
    }
    ,
    o.prototype.select = function(x, T, I) {
        if (this.isActive) {
            x = parseInt(x, 10);
            var q = this.cells.length;
            this.options.wrapAround && 1 < q && (0 > x ? this.x -= this.slideableWidth : x >= q && (this.x += this.slideableWidth)),
            (this.options.wrapAround || T) && (x = u.modulo(x, q)),
            this.cells[x] && (this.selectedIndex = x,
            this.setSelectedCell(),
            I ? this.positionSliderAtSelected() : this.startAnimation(),
            this.dispatchEvent("cellSelect"))
        }
    }
    ,
    o.prototype.previous = function(x) {
        this.select(this.selectedIndex - 1, x)
    }
    ,
    o.prototype.next = function(x) {
        this.select(this.selectedIndex + 1, x)
    }
    ,
    o.prototype.setSelectedCell = function() {
        this._removeSelectedCellClass(),
        this.selectedCell = this.cells[this.selectedIndex],
        this.selectedElement = this.selectedCell.element,
        v.add(this.selectedElement, "is-selected")
    }
    ,
    o.prototype._removeSelectedCellClass = function() {
        this.selectedCell && v.remove(this.selectedCell.element, "is-selected")
    }
    ,
    o.prototype.getCell = function(x) {
        for (var T, I = 0, q = this.cells.length; q > I; I++)
            if (T = this.cells[I],
            T.element == x)
                return T
    }
    ,
    o.prototype.getCells = function(x) {
        x = u.makeArray(x);
        for (var T = [], I = 0, q = x.length; q > I; I++) {
            var $ = x[I]
              , Y = this.getCell($);
            Y && T.push(Y)
        }
        return T
    }
    ,
    o.prototype.getCellElements = function() {
        for (var x = [], T = 0, I = this.cells.length; I > T; T++)
            x.push(this.cells[T].element);
        return x
    }
    ,
    o.prototype.getParentCell = function(x) {
        var T = this.getCell(x);
        return T || (x = u.getParent(x, ".flickity-slider > *"),
        this.getCell(x))
    }
    ,
    o.prototype.getAdjacentCellElements = function(x, T) {
        if (!x)
            return [this.selectedElement];
        T = T === void 0 ? this.selectedIndex : T;
        var I = this.cells.length;
        if (1 + 2 * x >= I)
            return this.getCellElements();
        for (var q = [], $ = T - x; T + x >= $; $++) {
            var Y = this.options.wrapAround ? u.modulo($, I) : $
              , l = this.cells[Y];
            l && q.push(l.element)
        }
        return q
    }
    ,
    o.prototype.uiChange = function() {
        this.emit("uiChange")
    }
    ,
    o.prototype.childUIPointerDown = function(x) {
        this.emitEvent("childUIPointerDown", [x])
    }
    ,
    o.prototype.onresize = function() {
        this.watchCSS(),
        this.resize()
    }
    ,
    u.debounceMethod(o, "onresize", 150),
    o.prototype.resize = function() {
        this.isActive && (this.getSize(),
        this.options.wrapAround && (this.x = u.modulo(this.x, this.slideableWidth)),
        this.positionCells(),
        this._getWrapShiftCells(),
        this.setGallerySize(),
        this.positionSliderAtSelected())
    }
    ;
    var _ = o.supportsConditionalCSS = function() {
        var x;
        return function() {
            if (x != null)
                return x;
            if (!k)
                return void (x = !1);
            var T = document.createElement("style")
              , I = document.createTextNode('body:after { content: "foo"; display: none; }');
            T.appendChild(I),
            document.head.appendChild(T);
            var q = k(document.body, ":after").content;
            return x = q.indexOf("foo") != -1,
            document.head.removeChild(T),
            x
        }
    }();
    return o.prototype.watchCSS = function() {
        var x = this.options.watchCSS;
        if (x) {
            var T = _();
            if (!T) {
                var I = x == "fallbackOn" ? "activate" : "deactivate";
                return void this[I]()
            }
            var q = k(this.element, ":after").content;
            q.indexOf("flickity") == -1 ? this.deactivate() : this.activate()
        }
    }
    ,
    o.prototype.onkeydown = function(x) {
        if (this.options.accessibility && (!document.activeElement || document.activeElement == this.element)) {
            if (x.keyCode == 37) {
                var T = this.options.rightToLeft ? "next" : "previous";
                this.uiChange(),
                this[T]()
            } else if (x.keyCode == 39) {
                var I = this.options.rightToLeft ? "previous" : "next";
                this.uiChange(),
                this[I]()
            }
        }
    }
    ,
    o.prototype.deactivate = function() {
        if (this.isActive) {
            v.remove(this.element, "flickity-enabled"),
            v.remove(this.element, "flickity-rtl");
            for (var x, T = 0, I = this.cells.length; I > T; T++)
                x = this.cells[T],
                x.destroy();
            this._removeSelectedCellClass(),
            this.element.removeChild(this.viewport),
            r(this.slider.children, this.element),
            this.options.accessibility && (this.element.removeAttribute("tabIndex"),
            a.unbind(this.element, "keydown", this)),
            this.isActive = !1,
            this.emit("deactivate")
        }
    }
    ,
    o.prototype.destroy = function() {
        this.deactivate(),
        this.isResizeBound && a.unbind(s, "resize", this),
        this.emit("destroy"),
        h && this.$element && h.removeData(this.element, "flickity"),
        delete this.element.flickityGUID,
        delete b[this.guid]
    }
    ,
    u.extend(o.prototype, e),
    o.setUnselectable = function(x) {
        "attachEvent"in s && x.setAttribute("unselectable", "on")
    }
    ,
    o.data = function(x) {
        x = u.getQueryElement(x);
        var T = x && x.flickityGUID;
        return T && b[T]
    }
    ,
    u.htmlInit(o, "flickity"),
    h && h.bridget && h.bridget("flickity", o),
    o.Cell = t,
    o
}),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define("unipointer/unipointer", ["eventEmitter/EventEmitter", "eventie/eventie"], function(g, a) {
        return v(s, g, a)
    }) : typeof exports == "object" ? module.exports = v(s, require("wolfy87-eventemitter"), require("eventie")) : s.Unipointer = v(s, s.EventEmitter, s.eventie)
}(window, function(s, v, g) {
    function a() {}
    a.prototype = new v,
    a.prototype.bindStartEvent = function(u) {
        this._bindStartEvent(u, !0)
    }
    ,
    a.prototype.unbindStartEvent = function(u) {
        this._bindStartEvent(u, !1)
    }
    ,
    a.prototype._bindStartEvent = function(u, t) {
        t = t === void 0 || !!t;
        var e = t ? "bind" : "unbind";
        s.navigator.pointerEnabled ? g[e](u, "pointerdown", this) : s.navigator.msPointerEnabled ? g[e](u, "MSPointerDown", this) : (g[e](u, "mousedown", this),
        g[e](u, "touchstart", this))
    }
    ,
    a.prototype.handleEvent = function(u) {
        var t = "on" + u.type;
        this[t] && this[t](u)
    }
    ,
    a.prototype.getTouch = function(u) {
        for (var t, e = 0, r = u.length; r > e; e++)
            if (t = u[e],
            t.identifier == this.pointerIdentifier)
                return t
    }
    ,
    a.prototype.onmousedown = function(u) {
        var t = u.button;
        t && t !== 0 && t !== 1 || this._pointerDown(u, u)
    }
    ,
    a.prototype.ontouchstart = function(u) {
        this._pointerDown(u, u.changedTouches[0])
    }
    ,
    a.prototype.onMSPointerDown = a.prototype.onpointerdown = function(u) {
        this._pointerDown(u, u)
    }
    ,
    a.prototype._pointerDown = function(u, t) {
        this.isPointerDown || (this.isPointerDown = !0,
        this.pointerIdentifier = t.pointerId === void 0 ? t.identifier : t.pointerId,
        this.pointerDown(u, t))
    }
    ,
    a.prototype.pointerDown = function(u, t) {
        this._bindPostStartEvents(u),
        this.emitEvent("pointerDown", [u, t])
    }
    ;
    var p = {
        mousedown: ["mousemove", "mouseup"],
        touchstart: ["touchmove", "touchend", "touchcancel"],
        pointerdown: ["pointermove", "pointerup", "pointercancel"],
        MSPointerDown: ["MSPointerMove", "MSPointerUp", "MSPointerCancel"]
    };
    return a.prototype._bindPostStartEvents = function(u) {
        if (u) {
            for (var t, e = p[u.type], r = u.preventDefault ? s : document, o = 0, h = e.length; h > o; o++)
                t = e[o],
                g.bind(r, t, this);
            this._boundPointerEvents = {
                events: e,
                node: r
            }
        }
    }
    ,
    a.prototype._unbindPostStartEvents = function() {
        var u = this._boundPointerEvents;
        if (u && u.events) {
            for (var t, e = 0, r = u.events.length; r > e; e++)
                t = u.events[e],
                g.unbind(u.node, t, this);
            delete this._boundPointerEvents
        }
    }
    ,
    a.prototype.onmousemove = function(u) {
        this._pointerMove(u, u)
    }
    ,
    a.prototype.onMSPointerMove = a.prototype.onpointermove = function(u) {
        u.pointerId == this.pointerIdentifier && this._pointerMove(u, u)
    }
    ,
    a.prototype.ontouchmove = function(u) {
        var t = this.getTouch(u.changedTouches);
        t && this._pointerMove(u, t)
    }
    ,
    a.prototype._pointerMove = function(u, t) {
        this.pointerMove(u, t)
    }
    ,
    a.prototype.pointerMove = function(u, t) {
        this.emitEvent("pointerMove", [u, t])
    }
    ,
    a.prototype.onmouseup = function(u) {
        this._pointerUp(u, u)
    }
    ,
    a.prototype.onMSPointerUp = a.prototype.onpointerup = function(u) {
        u.pointerId == this.pointerIdentifier && this._pointerUp(u, u)
    }
    ,
    a.prototype.ontouchend = function(u) {
        var t = this.getTouch(u.changedTouches);
        t && this._pointerUp(u, t)
    }
    ,
    a.prototype._pointerUp = function(u, t) {
        this._pointerDone(),
        this.pointerUp(u, t)
    }
    ,
    a.prototype.pointerUp = function(u, t) {
        this.emitEvent("pointerUp", [u, t])
    }
    ,
    a.prototype._pointerDone = function() {
        this.isPointerDown = !1,
        delete this.pointerIdentifier,
        this._unbindPostStartEvents(),
        this.pointerDone()
    }
    ,
    a.prototype.pointerDone = function() {}
    ,
    a.prototype.onMSPointerCancel = a.prototype.onpointercancel = function(u) {
        u.pointerId == this.pointerIdentifier && this._pointerCancel(u, u)
    }
    ,
    a.prototype.ontouchcancel = function(u) {
        var t = this.getTouch(u.changedTouches);
        t && this._pointerCancel(u, t)
    }
    ,
    a.prototype._pointerCancel = function(u, t) {
        this._pointerDone(),
        this.pointerCancel(u, t)
    }
    ,
    a.prototype.pointerCancel = function(u, t) {
        this.emitEvent("pointerCancel", [u, t])
    }
    ,
    a.getPointerPoint = function(u) {
        return {
            x: u.pageX === void 0 ? u.clientX : u.pageX,
            y: u.pageY === void 0 ? u.clientY : u.pageY
        }
    }
    ,
    a
}),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define("unidragger/unidragger", ["eventie/eventie", "unipointer/unipointer"], function(g, a) {
        return v(s, g, a)
    }) : typeof exports == "object" ? module.exports = v(s, require("eventie"), require("unipointer")) : s.Unidragger = v(s, s.eventie, s.Unipointer)
}(window, function(s, v, g) {
    function a(h) {
        h.preventDefault ? h.preventDefault() : h.returnValue = !1
    }
    function p() {}
    function u() {
        return !1
    }
    p.prototype = new g,
    p.prototype.bindHandles = function() {
        this._bindHandles(!0)
    }
    ,
    p.prototype.unbindHandles = function() {
        this._bindHandles(!1)
    }
    ;
    var t = s.navigator;
    p.prototype._bindHandles = function(h) {
        h = h === void 0 || !!h;
        for (var k = t.pointerEnabled ? function(_) {
            _.style.touchAction = h ? "none" : ""
        }
        : t.msPointerEnabled ? function(_) {
            _.style.msTouchAction = h ? "none" : ""
        }
        : function() {
            h && r(C)
        }
        , C, w = h ? "bind" : "unbind", b = 0, A = this.handles.length; A > b; b++)
            C = this.handles[b],
            this._bindStartEvent(C, h),
            k(C),
            v[w](C, "click", this)
    }
    ;
    var e = "attachEvent"in document.documentElement
      , r = e ? function(h) {
        h.nodeName == "IMG" && (h.ondragstart = u);
        for (var k, C = h.querySelectorAll("img"), w = 0, b = C.length; b > w; w++)
            k = C[w],
            k.ondragstart = u
    }
    : function() {}
    ;
    p.prototype.pointerDown = function(h, k) {
        if (h.target.nodeName == "INPUT" && h.target.type == "range")
            return this.isPointerDown = !1,
            void delete this.pointerIdentifier;
        this._dragPointerDown(h, k);
        var C = document.activeElement;
        C && C.blur && C.blur(),
        this._bindPostStartEvents(h),
        this.pointerDownScroll = p.getScrollPosition(),
        v.bind(s, "scroll", this),
        this.emitEvent("pointerDown", [h, k])
    }
    ,
    p.prototype._dragPointerDown = function(h, k) {
        this.pointerDownPoint = g.getPointerPoint(k);
        var C = h.type == "touchstart"
          , w = h.target.nodeName;
        C || w == "SELECT" || a(h)
    }
    ,
    p.prototype.pointerMove = function(h, k) {
        var C = this._dragPointerMove(h, k);
        this.emitEvent("pointerMove", [h, k, C]),
        this._dragMove(h, k, C)
    }
    ,
    p.prototype._dragPointerMove = function(h, k) {
        var C = g.getPointerPoint(k)
          , w = {
            x: C.x - this.pointerDownPoint.x,
            y: C.y - this.pointerDownPoint.y
        };
        return !this.isDragging && this.hasDragStarted(w) && this._dragStart(h, k),
        w
    }
    ,
    p.prototype.hasDragStarted = function(h) {
        return 3 < Math.abs(h.x) || 3 < Math.abs(h.y)
    }
    ,
    p.prototype.pointerUp = function(h, k) {
        this.emitEvent("pointerUp", [h, k]),
        this._dragPointerUp(h, k)
    }
    ,
    p.prototype._dragPointerUp = function(h, k) {
        this.isDragging ? this._dragEnd(h, k) : this._staticClick(h, k)
    }
    ,
    p.prototype.pointerDone = function() {
        v.unbind(s, "scroll", this)
    }
    ,
    p.prototype._dragStart = function(h, k) {
        this.isDragging = !0,
        this.dragStartPoint = p.getPointerPoint(k),
        this.isPreventingClicks = !0,
        this.dragStart(h, k)
    }
    ,
    p.prototype.dragStart = function(h, k) {
        this.emitEvent("dragStart", [h, k])
    }
    ,
    p.prototype._dragMove = function(h, k, C) {
        this.isDragging && this.dragMove(h, k, C)
    }
    ,
    p.prototype.dragMove = function(h, k, C) {
        a(h),
        this.emitEvent("dragMove", [h, k, C])
    }
    ,
    p.prototype._dragEnd = function(h, k) {
        this.isDragging = !1;
        var C = this;
        setTimeout(function() {
            delete C.isPreventingClicks
        }),
        this.dragEnd(h, k)
    }
    ,
    p.prototype.dragEnd = function(h, k) {
        this.emitEvent("dragEnd", [h, k])
    }
    ,
    p.prototype.pointerDone = function() {
        v.unbind(s, "scroll", this),
        delete this.pointerDownScroll
    }
    ,
    p.prototype.onclick = function(h) {
        this.isPreventingClicks && a(h)
    }
    ,
    p.prototype._staticClick = function(h, k) {
        if (!this.isIgnoringMouseUp || h.type != "mouseup") {
            var C = h.target.nodeName;
            if ((C == "INPUT" || C == "TEXTAREA") && h.target.focus(),
            this.staticClick(h, k),
            h.type != "mouseup") {
                this.isIgnoringMouseUp = !0;
                var w = this;
                setTimeout(function() {
                    delete w.isIgnoringMouseUp
                }, 400)
            }
        }
    }
    ,
    p.prototype.staticClick = function(h, k) {
        this.emitEvent("staticClick", [h, k])
    }
    ,
    p.prototype.onscroll = function() {
        var h = p.getScrollPosition()
          , k = this.pointerDownScroll.x - h.x
          , C = this.pointerDownScroll.y - h.y;
        (3 < Math.abs(k) || 3 < Math.abs(C)) && this._pointerDone()
    }
    ,
    p.getPointerPoint = function(h) {
        return {
            x: h.pageX === void 0 ? h.clientX : h.pageX,
            y: h.pageY === void 0 ? h.clientY : h.pageY
        }
    }
    ;
    var o = s.pageYOffset !== void 0;
    return p.getScrollPosition = function() {
        return {
            x: o ? s.pageXOffset : document.body.scrollLeft,
            y: o ? s.pageYOffset : document.body.scrollTop
        }
    }
    ,
    p.getPointerPoint = g.getPointerPoint,
    p
}),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define("flickity/js/drag", ["classie/classie", "eventie/eventie", "./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function(g, a, p, u, t) {
        return v(s, g, a, p, u, t)
    }) : typeof exports == "object" ? module.exports = v(s, require("desandro-classie"), require("eventie"), require("./flickity"), require("unidragger"), require("fizzy-ui-utils")) : s.Flickity = v(s, s.classie, s.eventie, s.Flickity, s.Unidragger, s.fizzyUIUtils)
}(window, function(s, v, g, a, p, u) {
    function t(o) {
        o.preventDefault ? o.preventDefault() : o.returnValue = !1
    }
    u.extend(a.defaults, {
        draggable: !0
    }),
    a.createMethods.push("_createDrag"),
    u.extend(a.prototype, p.prototype),
    a.prototype._createDrag = function() {
        this.on("activate", this.bindDrag),
        this.on("uiChange", this._uiChangeDrag),
        this.on("childUIPointerDown", this._childUIPointerDownDrag),
        this.on("deactivate", this.unbindDrag)
    }
    ,
    a.prototype.bindDrag = function() {
        this.options.draggable && !this.isDragBound && (v.add(this.element, "is-draggable"),
        this.handles = [this.viewport],
        this.bindHandles(),
        this.isDragBound = !0)
    }
    ,
    a.prototype.unbindDrag = function() {
        this.isDragBound && (v.remove(this.element, "is-draggable"),
        this.unbindHandles(),
        delete this.isDragBound)
    }
    ,
    a.prototype._uiChangeDrag = function() {
        delete this.isFreeScrolling
    }
    ,
    a.prototype._childUIPointerDownDrag = function(o) {
        t(o),
        this.pointerDownFocus(o)
    }
    ,
    a.prototype.pointerDown = function(o, h) {
        if (o.target.nodeName == "INPUT" && o.target.type == "range")
            return this.isPointerDown = !1,
            void delete this.pointerIdentifier;
        this._dragPointerDown(o, h);
        var k = document.activeElement;
        k && k.blur && k != this.element && k != document.body && k.blur(),
        this.pointerDownFocus(o),
        this.dragX = this.x,
        v.add(this.viewport, "is-pointer-down"),
        this._bindPostStartEvents(o),
        this.pointerDownScroll = p.getScrollPosition(),
        g.bind(s, "scroll", this),
        this.dispatchEvent("pointerDown", o, [h])
    }
    ;
    var e = {
        touchstart: !0,
        MSPointerDown: !0
    }
      , r = {
        INPUT: !0,
        SELECT: !0
    };
    return a.prototype.pointerDownFocus = function(o) {
        if (this.options.accessibility && !e[o.type] && !r[o.target.nodeName]) {
            var h = s.pageYOffset;
            this.element.focus(),
            s.pageYOffset != h && s.scrollTo(s.pageXOffset, h)
        }
    }
    ,
    a.prototype.hasDragStarted = function(o) {
        return 3 < Math.abs(o.x)
    }
    ,
    a.prototype.pointerUp = function(o, h) {
        v.remove(this.viewport, "is-pointer-down"),
        this.dispatchEvent("pointerUp", o, [h]),
        this._dragPointerUp(o, h)
    }
    ,
    a.prototype.pointerDone = function() {
        g.unbind(s, "scroll", this),
        delete this.pointerDownScroll
    }
    ,
    a.prototype.dragStart = function(o, h) {
        this.dragStartPosition = this.x,
        this.startAnimation(),
        this.dispatchEvent("dragStart", o, [h])
    }
    ,
    a.prototype.dragMove = function(o, h, k) {
        t(o),
        this.previousDragX = this.dragX;
        var C = this.options.rightToLeft ? -1 : 1
          , w = this.dragStartPosition + k.x * C;
        if (!this.options.wrapAround && this.cells.length) {
            var b = Math.max(-this.cells[0].target, this.dragStartPosition);
            w = w > b ? .5 * (w + b) : w;
            var A = Math.min(-this.getLastCell().target, this.dragStartPosition);
            w = A > w ? .5 * (w + A) : w
        }
        this.dragX = w,
        this.dragMoveTime = new Date,
        this.dispatchEvent("dragMove", o, [h, k])
    }
    ,
    a.prototype.dragEnd = function(o, h) {
        this.options.freeScroll && (this.isFreeScrolling = !0);
        var k = this.dragEndRestingSelect();
        if (this.options.freeScroll && !this.options.wrapAround) {
            var C = this.getRestingPosition();
            this.isFreeScrolling = -C > this.cells[0].target && -C < this.getLastCell().target
        } else
            this.options.freeScroll || k != this.selectedIndex || (k += this.dragEndBoostSelect());
        delete this.previousDragX,
        this.select(k),
        this.dispatchEvent("dragEnd", o, [h])
    }
    ,
    a.prototype.dragEndRestingSelect = function() {
        var o = this.getRestingPosition()
          , h = Math.abs(this.getCellDistance(-o, this.selectedIndex))
          , k = this._getClosestResting(o, h, 1)
          , C = this._getClosestResting(o, h, -1)
          , w = k.distance < C.distance ? k.index : C.index;
        return w
    }
    ,
    a.prototype._getClosestResting = function(o, h, k) {
        for (var C = this.selectedIndex, w = 1 / 0, b = this.options.contain && !this.options.wrapAround ? function(A, _) {
            return _ >= A
        }
        : function(A, _) {
            return _ > A
        }
        ; b(h, w) && (C += k,
        w = h,
        h = this.getCellDistance(-o, C),
        h !== null); )
            h = Math.abs(h);
        return {
            distance: w,
            index: C - k
        }
    }
    ,
    a.prototype.getCellDistance = function(o, h) {
        var k = this.cells.length
          , C = this.options.wrapAround && 1 < k
          , w = C ? u.modulo(h, k) : h
          , b = this.cells[w];
        if (!b)
            return null;
        var A = C ? this.slideableWidth * Math.floor(h / k) : 0;
        return o - (b.target + A)
    }
    ,
    a.prototype.dragEndBoostSelect = function() {
        if (this.previousDragX === void 0 || !this.dragMoveTime || 100 < new Date - this.dragMoveTime)
            return 0;
        var o = this.getCellDistance(-this.dragX, this.selectedIndex)
          , h = this.previousDragX - this.dragX;
        return 0 < o && 0 < h ? 1 : 0 > o && 0 > h ? -1 : 0
    }
    ,
    a.prototype.staticClick = function(o, h) {
        var k = this.getParentCell(o.target)
          , C = k && k.element
          , w = k && u.indexOf(this.cells, k);
        this.dispatchEvent("staticClick", o, [h, C, w])
    }
    ,
    a
}),
function(s, v) {
    typeof define == "function" && define.amd ? define("tap-listener/tap-listener", ["unipointer/unipointer"], function(g) {
        return v(s, g)
    }) : typeof exports == "object" ? module.exports = v(s, require("unipointer")) : s.TapListener = v(s, s.Unipointer)
}(window, function(s, v) {
    function g(p) {
        this.bindTap(p)
    }
    g.prototype = new v,
    g.prototype.bindTap = function(p) {
        p && (this.unbindTap(),
        this.tapElement = p,
        this._bindStartEvent(p, !0))
    }
    ,
    g.prototype.unbindTap = function() {
        this.tapElement && (this._bindStartEvent(this.tapElement, !0),
        delete this.tapElement)
    }
    ;
    var a = s.pageYOffset !== void 0;
    return g.prototype.pointerUp = function(p, u) {
        if (!this.isIgnoringMouseUp || p.type != "mouseup") {
            var t = v.getPointerPoint(u)
              , e = this.tapElement.getBoundingClientRect()
              , r = a ? s.pageXOffset : document.body.scrollLeft
              , o = a ? s.pageYOffset : document.body.scrollTop
              , h = t.x >= e.left + r && t.x <= e.right + r && t.y >= e.top + o && t.y <= e.bottom + o;
            h && this.emitEvent("tap", [p, u]),
            p.type != "mouseup" && (this.isIgnoringMouseUp = !0,
            setTimeout(function() {
                delete this.isIgnoringMouseUp
            }
            .bind(this), 320))
        }
    }
    ,
    g.prototype.destroy = function() {
        this.pointerDone(),
        this.unbindTap()
    }
    ,
    g
}),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define("flickity/js/prev-next-button", ["eventie/eventie", "./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function(g, a, p, u) {
        return v(s, g, a, p, u)
    }) : typeof exports == "object" ? module.exports = v(s, require("eventie"), require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")) : v(s, s.eventie, s.Flickity, s.TapListener, s.fizzyUIUtils)
}(window, function(s, v, g, a, p) {
    function u(o, h) {
        this.direction = o,
        this.parent = h,
        this._create()
    }
    function t(o) {
        return typeof o == "string" ? o : "M " + o.x0 + ",50 L " + o.x1 + "," + (o.y1 + 50) + " L " + o.x2 + "," + (o.y2 + 50) + " L " + o.x3 + ",50  L " + o.x2 + "," + (50 - o.y2) + " L " + o.x1 + "," + (50 - o.y1) + " Z"
    }
    var e = "http://www.w3.org/2000/svg"
      , r = function() {
        var o;
        return function() {
            if (o !== void 0)
                return o;
            var h = document.createElement("div");
            return h.innerHTML = "<svg/>",
            o = (h.firstChild && h.firstChild.namespaceURI) == e
        }
    }();
    return u.prototype = new a,
    u.prototype._create = function() {
        this.isEnabled = !0,
        this.isPrevious = this.direction == -1;
        var o = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == o;
        var h = this.element = document.createElement("button");
        if (h.className = "flickity-prev-next-button",
        h.className += this.isPrevious ? " previous" : " next",
        h.setAttribute("type", "button"),
        this.disable(),
        h.setAttribute("aria-label", this.isPrevious ? "previous" : "next"),
        g.setUnselectable(h),
        r()) {
            var k = this.createSVG();
            h.appendChild(k)
        } else
            this.setArrowText(),
            h.className += " no-svg";
        var C = this;
        this.onCellSelect = function() {
            C.update()
        }
        ,
        this.parent.on("cellSelect", this.onCellSelect),
        this.on("tap", this.onTap),
        this.on("pointerDown", function(w, b) {
            C.parent.childUIPointerDown(b)
        })
    }
    ,
    u.prototype.activate = function() {
        this.bindTap(this.element),
        v.bind(this.element, "click", this),
        this.parent.element.appendChild(this.element)
    }
    ,
    u.prototype.deactivate = function() {
        this.parent.element.removeChild(this.element),
        a.prototype.destroy.call(this),
        v.unbind(this.element, "click", this)
    }
    ,
    u.prototype.createSVG = function() {
        var o = document.createElementNS(e, "svg");
        o.setAttribute("viewBox", "0 0 100 100");
        var h = document.createElementNS(e, "path")
          , k = t(this.parent.options.arrowShape);
        return h.setAttribute("d", k),
        h.setAttribute("class", "arrow"),
        this.isLeft || h.setAttribute("transform", "translate(100, 100) rotate(180) "),
        o.appendChild(h),
        o
    }
    ,
    u.prototype.setArrowText = function() {
        var o = this.parent.options
          , h = this.isLeft ? o.leftArrowText : o.rightArrowText;
        p.setText(this.element, h)
    }
    ,
    u.prototype.onTap = function() {
        if (this.isEnabled) {
            this.parent.uiChange();
            var o = this.isPrevious ? "previous" : "next";
            this.parent[o]()
        }
    }
    ,
    u.prototype.handleEvent = p.handleEvent,
    u.prototype.onclick = function() {
        var o = document.activeElement;
        o && o == this.element && this.onTap()
    }
    ,
    u.prototype.enable = function() {
        this.isEnabled || (this.element.disabled = !1,
        this.isEnabled = !0)
    }
    ,
    u.prototype.disable = function() {
        this.isEnabled && (this.element.disabled = !0,
        this.isEnabled = !1)
    }
    ,
    u.prototype.update = function() {
        var o = this.parent.cells;
        if (this.parent.options.wrapAround && 1 < o.length)
            return void this.enable();
        var h = o.length ? o.length - 1 : 0
          , k = this.isPrevious ? 0 : h
          , C = this.parent.selectedIndex == k ? "disable" : "enable";
        this[C]()
    }
    ,
    u.prototype.destroy = function() {
        this.deactivate()
    }
    ,
    p.extend(g.defaults, {
        prevNextButtons: !0,
        leftArrowText: "\u2039",
        rightArrowText: "\u203A",
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    }),
    g.createMethods.push("_createPrevNextButtons"),
    g.prototype._createPrevNextButtons = function() {
        this.options.prevNextButtons && (this.prevButton = new u(-1,this),
        this.nextButton = new u(1,this),
        this.on("activate", this.activatePrevNextButtons))
    }
    ,
    g.prototype.activatePrevNextButtons = function() {
        this.prevButton.activate(),
        this.nextButton.activate(),
        this.on("deactivate", this.deactivatePrevNextButtons)
    }
    ,
    g.prototype.deactivatePrevNextButtons = function() {
        this.prevButton.deactivate(),
        this.nextButton.deactivate(),
        this.off("deactivate", this.deactivatePrevNextButtons)
    }
    ,
    g.PrevNextButton = u,
    g
}),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define("flickity/js/page-dots", ["eventie/eventie", "./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function(g, a, p, u) {
        return v(s, g, a, p, u)
    }) : typeof exports == "object" ? module.exports = v(s, require("eventie"), require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")) : v(s, s.eventie, s.Flickity, s.TapListener, s.fizzyUIUtils)
}(window, function(s, v, g, a, p) {
    function u(t) {
        this.parent = t,
        this._create()
    }
    return u.prototype = new a,
    u.prototype._create = function() {
        this.holder = document.createElement("ol"),
        this.holder.className = "flickity-page-dots",
        g.setUnselectable(this.holder),
        this.dots = [];
        var t = this;
        this.onCellSelect = function() {
            t.updateSelected()
        }
        ,
        this.parent.on("cellSelect", this.onCellSelect),
        this.on("tap", this.onTap),
        this.on("pointerDown", function(e, r) {
            t.parent.childUIPointerDown(r)
        })
    }
    ,
    u.prototype.activate = function() {
        this.setDots(),
        this.bindTap(this.holder),
        this.parent.element.appendChild(this.holder)
    }
    ,
    u.prototype.deactivate = function() {
        this.parent.element.removeChild(this.holder),
        a.prototype.destroy.call(this)
    }
    ,
    u.prototype.setDots = function() {
        var t = this.parent.cells.length - this.dots.length;
        0 < t ? this.addDots(t) : 0 > t && this.removeDots(-t)
    }
    ,
    u.prototype.addDots = function(t) {
        for (var e, r = document.createDocumentFragment(), o = []; t; )
            e = document.createElement("li"),
            e.className = "dot",
            r.appendChild(e),
            o.push(e),
            t--;
        this.holder.appendChild(r),
        this.dots = this.dots.concat(o)
    }
    ,
    u.prototype.removeDots = function(t) {
        for (var e, r = this.dots.splice(this.dots.length - t, t), o = 0, h = r.length; h > o; o++)
            e = r[o],
            this.holder.removeChild(e)
    }
    ,
    u.prototype.updateSelected = function() {
        this.selectedDot && (this.selectedDot.className = "dot"),
        this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex],
        this.selectedDot.className = "dot is-selected")
    }
    ,
    u.prototype.onTap = function(t) {
        var e = t.target;
        if (e.nodeName == "LI") {
            this.parent.uiChange();
            var r = p.indexOf(this.dots, e);
            this.parent.select(r)
        }
    }
    ,
    u.prototype.destroy = function() {
        this.deactivate()
    }
    ,
    g.PageDots = u,
    p.extend(g.defaults, {
        pageDots: !0
    }),
    g.createMethods.push("_createPageDots"),
    g.prototype._createPageDots = function() {
        this.options.pageDots && (this.pageDots = new u(this),
        this.on("activate", this.activatePageDots),
        this.on("cellAddedRemoved", this.onCellAddedRemovedPageDots),
        this.on("deactivate", this.deactivatePageDots))
    }
    ,
    g.prototype.activatePageDots = function() {
        this.pageDots.activate()
    }
    ,
    g.prototype.onCellAddedRemovedPageDots = function() {
        this.pageDots.setDots()
    }
    ,
    g.prototype.deactivatePageDots = function() {
        this.pageDots.deactivate()
    }
    ,
    g.PageDots = u,
    g
}),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define("flickity/js/player", ["eventEmitter/EventEmitter", "eventie/eventie", "fizzy-ui-utils/utils", "./flickity"], function(g, a, p, u) {
        return v(g, a, p, u)
    }) : typeof exports == "object" ? module.exports = v(require("wolfy87-eventemitter"), require("eventie"), require("fizzy-ui-utils"), require("./flickity")) : v(s.EventEmitter, s.eventie, s.fizzyUIUtils, s.Flickity)
}(window, function(s, v, g, a) {
    function p(e) {
        if (this.parent = e,
        this.state = "stopped",
        t) {
            var r = this;
            this.onVisibilityChange = function() {
                r.visibilityChange()
            }
        }
    }
    var u, t;
    return "hidden"in document ? (u = "hidden",
    t = "visibilitychange") : "webkitHidden"in document && (u = "webkitHidden",
    t = "webkitvisibilitychange"),
    p.prototype = new s,
    p.prototype.play = function() {
        this.state != "playing" && (this.state = "playing",
        t && document.addEventListener(t, this.onVisibilityChange, !1),
        this.tick())
    }
    ,
    p.prototype.tick = function() {
        if (this.state == "playing") {
            var e = this.parent.options.autoPlay;
            e = typeof e == "number" ? e : 3e3;
            var r = this;
            this.clear(),
            this.timeout = setTimeout(function() {
                r.parent.next(!0),
                r.tick()
            }, e)
        }
    }
    ,
    p.prototype.stop = function() {
        this.state = "stopped",
        this.clear(),
        t && document.removeEventListener(t, this.onVisibilityChange, !1)
    }
    ,
    p.prototype.clear = function() {
        clearTimeout(this.timeout)
    }
    ,
    p.prototype.pause = function() {
        this.state == "playing" && (this.state = "paused",
        this.clear())
    }
    ,
    p.prototype.unpause = function() {
        this.state == "paused" && this.play()
    }
    ,
    p.prototype.visibilityChange = function() {
        var e = document[u];
        this[e ? "pause" : "unpause"]()
    }
    ,
    g.extend(a.defaults, {
        pauseAutoPlayOnHover: !0
    }),
    a.createMethods.push("_createPlayer"),
    a.prototype._createPlayer = function() {
        this.player = new p(this),
        this.on("activate", this.activatePlayer),
        this.on("uiChange", this.stopPlayer),
        this.on("pointerDown", this.stopPlayer),
        this.on("deactivate", this.deactivatePlayer)
    }
    ,
    a.prototype.activatePlayer = function() {
        this.options.autoPlay && (this.player.play(),
        v.bind(this.element, "mouseenter", this),
        this.isMouseenterBound = !0)
    }
    ,
    a.prototype.playPlayer = function() {
        this.player.play()
    }
    ,
    a.prototype.stopPlayer = function() {
        this.player.stop()
    }
    ,
    a.prototype.pausePlayer = function() {
        this.player.pause()
    }
    ,
    a.prototype.unpausePlayer = function() {
        this.player.unpause()
    }
    ,
    a.prototype.deactivatePlayer = function() {
        this.player.stop(),
        this.isMouseenterBound && (v.unbind(this.element, "mouseenter", this),
        delete this.isMouseenterBound)
    }
    ,
    a.prototype.onmouseenter = function() {
        this.options.pauseAutoPlayOnHover && (this.player.pause(),
        v.bind(this.element, "mouseleave", this))
    }
    ,
    a.prototype.onmouseleave = function() {
        this.player.unpause(),
        v.unbind(this.element, "mouseleave", this)
    }
    ,
    a.Player = p,
    a
}),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function(g, a) {
        return v(s, g, a)
    }) : typeof exports == "object" ? module.exports = v(s, require("./flickity"), require("fizzy-ui-utils")) : v(s, s.Flickity, s.fizzyUIUtils)
}(window, function(s, v, g) {
    function a(p) {
        for (var u, t = document.createDocumentFragment(), e = 0, r = p.length; r > e; e++)
            u = p[e],
            t.appendChild(u.element);
        return t
    }
    return v.prototype.insert = function(p, u) {
        var t = this._makeCells(p);
        if (t && t.length) {
            var e = this.cells.length;
            u = u === void 0 ? e : u;
            var r = a(t)
              , o = u == e;
            if (o)
                this.slider.appendChild(r);
            else {
                var h = this.cells[u].element;
                this.slider.insertBefore(r, h)
            }
            if (u === 0)
                this.cells = t.concat(this.cells);
            else if (o)
                this.cells = this.cells.concat(t);
            else {
                var k = this.cells.splice(u, e - u);
                this.cells = this.cells.concat(t).concat(k)
            }
            this._sizeCells(t);
            var C = u > this.selectedIndex ? 0 : t.length;
            this._cellAddedRemoved(u, C)
        }
    }
    ,
    v.prototype.append = function(p) {
        this.insert(p, this.cells.length)
    }
    ,
    v.prototype.prepend = function(p) {
        this.insert(p, 0)
    }
    ,
    v.prototype.remove = function(p) {
        var u, t, e, r = this.getCells(p), o = 0;
        for (u = 0,
        t = r.length; t > u; u++) {
            e = r[u];
            var h = g.indexOf(this.cells, e) < this.selectedIndex;
            o -= h ? 1 : 0
        }
        for (u = 0,
        t = r.length; t > u; u++)
            e = r[u],
            e.remove(),
            g.removeFrom(this.cells, e);
        r.length && this._cellAddedRemoved(0, o)
    }
    ,
    v.prototype._cellAddedRemoved = function(p, u) {
        u = u || 0,
        this.selectedIndex += u,
        this.selectedIndex = Math.max(0, Math.min(this.cells.length - 1, this.selectedIndex)),
        this.emitEvent("cellAddedRemoved", [p, u]),
        this.cellChange(p, !0)
    }
    ,
    v.prototype.cellSizeChange = function(p) {
        var u = this.getCell(p);
        if (u) {
            u.getSize();
            var t = g.indexOf(this.cells, u);
            this.cellChange(t)
        }
    }
    ,
    v.prototype.cellChange = function(p, u) {
        var t = this.slideableWidth;
        if (this._positionCells(p),
        this._getWrapShiftCells(),
        this.setGallerySize(),
        this.options.freeScroll) {
            var e = t - this.slideableWidth;
            this.x += e * this.cellAlign,
            this.positionSlider()
        } else
            u && this.positionSliderAtSelected(),
            this.select(this.selectedIndex)
    }
    ,
    v
}),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define("flickity/js/lazyload", ["classie/classie", "eventie/eventie", "./flickity", "fizzy-ui-utils/utils"], function(g, a, p, u) {
        return v(s, g, a, p, u)
    }) : typeof exports == "object" ? module.exports = v(s, require("desandro-classie"), require("eventie"), require("./flickity"), require("fizzy-ui-utils")) : v(s, s.classie, s.eventie, s.Flickity, s.fizzyUIUtils)
}(window, function(s, v, g, a, p) {
    "use strict";
    function u(e) {
        if (e.nodeName == "IMG" && e.getAttribute("data-flickity-lazyload"))
            return [e];
        var r = e.querySelectorAll("img[data-flickity-lazyload]");
        return p.makeArray(r)
    }
    function t(e, r) {
        this.img = e,
        this.flickity = r,
        this.load()
    }
    return a.createMethods.push("_createLazyload"),
    a.prototype._createLazyload = function() {
        this.on("cellSelect", this.lazyLoad)
    }
    ,
    a.prototype.lazyLoad = function() {
        var e = this.options.lazyLoad;
        if (e) {
            for (var r = typeof e == "number" ? e : 0, o = this.getAdjacentCellElements(r), h = [], k = 0, C = o.length; C > k; k++) {
                var w = o[k]
                  , b = u(w);
                h = h.concat(b)
            }
            for (k = 0,
            C = h.length; C > k; k++) {
                var A = h[k];
                new t(A,this)
            }
        }
    }
    ,
    t.prototype.handleEvent = p.handleEvent,
    t.prototype.load = function() {
        g.bind(this.img, "load", this),
        g.bind(this.img, "error", this),
        this.img.src = this.img.getAttribute("data-flickity-lazyload"),
        this.img.removeAttribute("data-flickity-lazyload")
    }
    ,
    t.prototype.onload = function(e) {
        this.complete(e, "flickity-lazyloaded")
    }
    ,
    t.prototype.onerror = function(e) {
        this.complete(e, "flickity-lazyerror")
    }
    ,
    t.prototype.complete = function(e, r) {
        g.unbind(this.img, "load", this),
        g.unbind(this.img, "error", this);
        var o = this.flickity.getParentCell(this.img)
          , h = o && o.element;
        this.flickity.cellSizeChange(h),
        v.add(this.img, r),
        this.flickity.dispatchEvent("lazyLoad", e, h)
    }
    ,
    a.LazyLoader = t,
    a
}),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], v) : typeof exports == "object" && (module.exports = v(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")))
}(window, function(s) {
    return s
}),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define("flickity-as-nav-for/as-nav-for", ["classie/classie", "flickity/js/index", "fizzy-ui-utils/utils"], function(g, a, p) {
        return v(s, g, a, p)
    }) : typeof exports == "object" ? module.exports = v(s, require("desandro-classie"), require("flickity"), require("fizzy-ui-utils")) : s.Flickity = v(s, s.classie, s.Flickity, s.fizzyUIUtils)
}(window, function(s, v, g, a) {
    return g.createMethods.push("_createAsNavFor"),
    g.prototype._createAsNavFor = function() {
        this.on("activate", this.activateAsNavFor),
        this.on("deactivate", this.deactivateAsNavFor),
        this.on("destroy", this.destroyAsNavFor);
        var p = this.options.asNavFor;
        if (p) {
            var u = this;
            setTimeout(function() {
                u.setNavCompanion(p)
            })
        }
    }
    ,
    g.prototype.setNavCompanion = function(p) {
        p = a.getQueryElement(p);
        var u = g.data(p);
        if (u && u != this) {
            this.navCompanion = u;
            var t = this;
            this.onNavCompanionSelect = function() {
                t.navCompanionSelect()
            }
            ,
            u.on("cellSelect", this.onNavCompanionSelect),
            this.on("staticClick", this.onNavStaticClick),
            this.navCompanionSelect()
        }
    }
    ,
    g.prototype.navCompanionSelect = function() {
        if (this.navCompanion) {
            var p = this.navCompanion.selectedIndex;
            this.select(p),
            this.removeNavSelectedElement(),
            this.selectedIndex == p && (this.navSelectedElement = this.cells[p].element,
            v.add(this.navSelectedElement, "is-nav-selected"))
        }
    }
    ,
    g.prototype.activateAsNavFor = function() {
        this.navCompanionSelect()
    }
    ,
    g.prototype.removeNavSelectedElement = function() {
        this.navSelectedElement && (v.remove(this.navSelectedElement, "is-nav-selected"),
        delete this.navSelectedElement)
    }
    ,
    g.prototype.onNavStaticClick = function(p, u, t, e) {
        typeof e == "number" && this.navCompanion.select(e)
    }
    ,
    g.prototype.deactivateAsNavFor = function() {
        this.removeNavSelectedElement()
    }
    ,
    g.prototype.destroyAsNavFor = function() {
        this.navCompanion && (this.navCompanion.off("cellSelect", this.onNavCompanionSelect),
        this.off("staticClick", this.onNavStaticClick),
        delete this.navCompanion)
    }
    ,
    g
}),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define("imagesloaded/imagesloaded", ["eventEmitter/EventEmitter", "eventie/eventie"], function(g, a) {
        return v(s, g, a)
    }) : typeof module == "object" && module.exports ? module.exports = v(s, require("wolfy87-eventemitter"), require("eventie")) : s.imagesLoaded = v(s, s.EventEmitter, s.eventie)
}(window, function(s, v, g) {
    function a(b, A) {
        for (var _ in A)
            b[_] = A[_];
        return b
    }
    function p(b) {
        return k.call(b) == "[object Array]"
    }
    function u(b) {
        var A = [];
        if (p(b))
            A = b;
        else if (typeof b.length == "number")
            for (var _ = 0; _ < b.length; _++)
                A.push(b[_]);
        else
            A.push(b);
        return A
    }
    function t(b, A, _) {
        if (!(this instanceof t))
            return new t(b,A,_);
        typeof b == "string" && (b = document.querySelectorAll(b)),
        this.elements = u(b),
        this.options = a({}, this.options),
        typeof A == "function" ? _ = A : a(this.options, A),
        _ && this.on("always", _),
        this.getImages(),
        o && (this.jqDeferred = new o.Deferred);
        var x = this;
        setTimeout(function() {
            x.check()
        })
    }
    function e(b) {
        this.img = b
    }
    function r(b, A) {
        this.url = b,
        this.element = A,
        this.img = new Image
    }
    var o = s.jQuery
      , h = s.console
      , k = Object.prototype.toString;
    t.prototype = new v,
    t.prototype.options = {},
    t.prototype.getImages = function() {
        this.images = [];
        for (var b, A = 0; A < this.elements.length; A++)
            b = this.elements[A],
            this.addElementImages(b)
    }
    ,
    t.prototype.addElementImages = function(b) {
        b.nodeName == "IMG" && this.addImage(b),
        this.options.background === !0 && this.addElementBackgroundImages(b);
        var A = b.nodeType;
        if (A && C[A]) {
            for (var _, x = b.querySelectorAll("img"), T = 0; T < x.length; T++)
                _ = x[T],
                this.addImage(_);
            if (typeof this.options.background == "string") {
                var I = b.querySelectorAll(this.options.background);
                for (T = 0; T < I.length; T++) {
                    var q = I[T];
                    this.addElementBackgroundImages(q)
                }
            }
        }
    }
    ;
    var C = {
        1: !0,
        9: !0,
        11: !0
    };
    t.prototype.addElementBackgroundImages = function(b) {
        for (var A, _ = w(b), x = /url\(['"]*([^'"\)]+)['"]*\)/gi, T = x.exec(_.backgroundImage); T !== null; )
            A = T && T[1],
            A && this.addBackground(A, b),
            T = x.exec(_.backgroundImage)
    }
    ;
    var w = s.getComputedStyle || function(b) {
        return b.currentStyle
    }
    ;
    return t.prototype.addImage = function(b) {
        var A = new e(b);
        this.images.push(A)
    }
    ,
    t.prototype.addBackground = function(b, A) {
        var _ = new r(b,A);
        this.images.push(_)
    }
    ,
    t.prototype.check = function() {
        function b(T, I, q) {
            setTimeout(function() {
                A.progress(T, I, q)
            })
        }
        var A = this;
        if (this.progressedCount = 0,
        this.hasAnyBroken = !1,
        !this.images.length)
            return void this.complete();
        for (var _, x = 0; x < this.images.length; x++)
            _ = this.images[x],
            _.once("progress", b),
            _.check()
    }
    ,
    t.prototype.progress = function(b, A, _) {
        this.progressedCount++,
        this.hasAnyBroken = this.hasAnyBroken || !b.isLoaded,
        this.emit("progress", this, b, A),
        this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, b),
        this.progressedCount == this.images.length && this.complete(),
        this.options.debug && h && h.log("progress: " + _, b, A)
    }
    ,
    t.prototype.complete = function() {
        var b = this.hasAnyBroken ? "fail" : "done";
        if (this.isComplete = !0,
        this.emit(b, this),
        this.emit("always", this),
        this.jqDeferred) {
            var A = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[A](this)
        }
    }
    ,
    e.prototype = new v,
    e.prototype.check = function() {
        var b = this.getIsImageComplete();
        return b ? void this.confirm(this.img.naturalWidth !== 0, "naturalWidth") : (this.proxyImage = new Image,
        g.bind(this.proxyImage, "load", this),
        g.bind(this.proxyImage, "error", this),
        g.bind(this.img, "load", this),
        g.bind(this.img, "error", this),
        void (this.proxyImage.src = this.img.src))
    }
    ,
    e.prototype.getIsImageComplete = function() {
        return this.img.complete && this.img.naturalWidth !== void 0
    }
    ,
    e.prototype.confirm = function(b, A) {
        this.isLoaded = b,
        this.emit("progress", this, this.img, A)
    }
    ,
    e.prototype.handleEvent = function(b) {
        var A = "on" + b.type;
        this[A] && this[A](b)
    }
    ,
    e.prototype.onload = function() {
        this.confirm(!0, "onload"),
        this.unbindEvents()
    }
    ,
    e.prototype.onerror = function() {
        this.confirm(!1, "onerror"),
        this.unbindEvents()
    }
    ,
    e.prototype.unbindEvents = function() {
        g.unbind(this.proxyImage, "load", this),
        g.unbind(this.proxyImage, "error", this),
        g.unbind(this.img, "load", this),
        g.unbind(this.img, "error", this)
    }
    ,
    r.prototype = new e,
    r.prototype.check = function() {
        g.bind(this.img, "load", this),
        g.bind(this.img, "error", this),
        this.img.src = this.url;
        var b = this.getIsImageComplete();
        b && (this.confirm(this.img.naturalWidth !== 0, "naturalWidth"),
        this.unbindEvents())
    }
    ,
    r.prototype.unbindEvents = function() {
        g.unbind(this.img, "load", this),
        g.unbind(this.img, "error", this)
    }
    ,
    r.prototype.confirm = function(b, A) {
        this.isLoaded = b,
        this.emit("progress", this, this.element, A)
    }
    ,
    t.makeJQueryPlugin = function(b) {
        b = b || s.jQuery,
        b && (o = b,
        o.fn.imagesLoaded = function(A, _) {
            var x = new t(this,A,_);
            return x.jqDeferred.promise(o(this))
        }
        )
    }
    ,
    t.makeJQueryPlugin(),
    t
}),
function(s, v) {
    "use strict";
    typeof define == "function" && define.amd ? define(["flickity/js/index", "imagesloaded/imagesloaded"], function(g, a) {
        return v(s, g, a)
    }) : typeof exports == "object" ? module.exports = v(s, require("flickity"), require("imagesloaded")) : s.Flickity = v(s, s.Flickity, s.imagesLoaded)
}(window, function(s, v, g) {
    "use strict";
    return v.createMethods.push("_createImagesLoaded"),
    v.prototype._createImagesLoaded = function() {
        this.on("activate", this.imagesLoaded)
    }
    ,
    v.prototype.imagesLoaded = function() {
        function a(u, t) {
            var e = p.getParentCell(t.img);
            p.cellSizeChange(e && e.element),
            p.options.freeScroll || p.positionSliderAtSelected()
        }
        if (this.options.imagesLoaded) {
            var p = this;
            g(this.slider).on("progress", a)
        }
    }
    ,
    v
});
//# sourceMappingURL=/s/files/1/1819/3663/t/30/assets/plugins.js.map?v=117064359216413649611679173928
